(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ajax-cart-new"] && !Shopify.designMode) return;
  try {
    
  if (!document.querySelector('.new-cart')) {
    // Classes
    const acNewCls = 'ac-new';
    const acNewActiveCls = 'ac-new--active';
    const acNewBoxCls = 'ac-new__box';
    const acNewLoadingCls = 'ac-new__loading';
    const acNewLoadingActiveCls = 'ac-new__loading--active';
    const acNewHeaderCloseCls = 'ac-new-header__close';
    const acNewMainCls = 'ac-new__main';
    const acNewItemsCls = 'ac-new__items';
    const acNewFooterCls = 'ac-new-footer';
    const acNewPairingCls = 'ac-new-pairing';
    const acNewPairingImgCls = 'ac-new-pairing__img';
    const acNewPairingPriceCls = 'ac-new-pairing__price';
    const acNewPairingSelectCls = 'ac-new-pairing__select';
    const acNewPairingAddCls = 'ac-new-pairing__add';
    const acNewPairingFormCls = 'ac-new-pairing__main-bottom';
    const acNewRemoveCls = 'ac-new-item__remove';
    const acNewQuantityUpCls = 'ac-new-selector__plus';
    const acNewQuantityDownCls = 'ac-new-selector__minus';
    const acNewSelectorCls = 'ac-new-selector';
    const acNewSelectorInputCls = 'ac-new-selector__input';
    const acNewFooterShippingCls = 'ac-new-footer__row--shipping';
    const acNewFooterShippingActiveCls = 'ac-new-footer__row--active';
    const acNewAnnouncementTextCls = 'ac-new-announcement__text';
    const acDiscountCodeCls = 'ac-new-discount-code';
    const acDiscountCodeRemoveCls = 'ac-new-discount-code__remove';
    const acDiscountCodeNameCls = 'ac-new-discount-code__name';
    const acSubmitCodeFormCls = 'ac-new-discounts__form';
    const acSubmitCodeFormInputCls = 'ac-new-discounts__input';
    const acSubmitCodeFormButtonCls = 'ac-new-discounts__button';
    const acSubmitCodeFormErrorCls = 'ac-new-discounts__error';
    const acSubmitCodeFormErrorActiveCls = 'ac-new-discounts__error--active';
    const acNewGwCls = 'ac-new-giftwrap';
    const acNewGwActiveCls = 'ac-new-giftwrap--active';
    const acNewGwHeaderCls = 'ac-new-giftwrap__header';
    const acNewGwBodyCls = 'ac-new-giftwrap__body';
    const acNewGwMinusCls = 'ac-new-gw-selector__minus';
    const acNewGwPlusCls = 'ac-new-gw-selector__plus';
    const acNewGwInputCls = 'ac-new-gw-selector__input';
    const acNewGwFormCls = 'ac-new-giftwrap-prod__bottom';
    const acNewGnCls = 'ac-new-giftnote';
    const acNewGnActiveCls = 'ac-new-giftnote--active';
    const acNewGnHeaderCls = 'ac-new-giftnote__header';
    const acNewGnBodyCls = 'ac-new-giftnote__body';
    const acNewGnNoteCls = 'ac-new-giftnote__note';

    let letterTeetherGiftSyncing = false;
    let letterTeetherGiftConfig = null;
    let bogosCheckoutPrepared = false;
    let acCartRefreshing = false;

    try {
      const letterTeetherGiftConfigEl = document.getElementById('letter-teether-gift-config');
      if (letterTeetherGiftConfigEl) {
        letterTeetherGiftConfig = JSON.parse(letterTeetherGiftConfigEl.textContent);
      }
    } catch (err) {
      console.error('Failed to parse letter teether gift config', err);
    }

    function isBogosGiftLine(item) {
      if (!item) return false;
      const props = item.properties || {};
      if (Object.keys(props).some((key) => key.toLowerCase().includes('bogos'))) return true;
      const giftHandles = ['the-letter-teether', 'the-teether'];
      if (giftHandles.includes(item.handle) && item.final_line_price === 0) return true;
      const title = `${item.product_title || ''} ${item.title || ''}`.toLowerCase();
      return title.includes('100% off');
    }

    function getLetterTeetherLines(cart) {
      if (!letterTeetherGiftConfig?.productId) return [];

      return cart.items.filter((item) => item.product_id === letterTeetherGiftConfig.productId);
    }

    function getLetterTeetherGiftLines(cart) {
      return getLetterTeetherLines(cart).filter((item) => isBogosGiftLine(item));
    }

    function getInvalidLetterTeetherGiftLines(cart) {
      return getLetterTeetherLines(cart).filter((item) => !isBogosGiftLine(item));
    }

    async function enforceBogosGiftQuantity(cart) {
      const overflow = cart.items.filter((item) => isBogosGiftLine(item) && item.quantity > 1);
      if (!overflow.length) return false;

      const updates = {};
      overflow.forEach((item) => {
        updates[item.key] = 1;
      });

      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ updates }),
      });

      if (!res.ok) {
        throw new Error(`Failed to enforce free gift quantity: ${res.status}`);
      }

      return true;
    }

    function getQualifyingSubtotal(cart) {
      if (!letterTeetherGiftConfig?.productId) return cart.original_total_price;

      return cart.items
        .filter((item) => item.product_id !== letterTeetherGiftConfig.productId)
        .reduce((sum, item) => sum + item.original_line_price, 0);
    }

    function triggerBogosGifts(cart) {
      document.dispatchEvent(new CustomEvent('bogos:cart-change', { detail: cart }));
      document.dispatchEvent(new CustomEvent('bogos:fetch-cart', { detail: cart }));
      document.dispatchEvent(new CustomEvent('bogos:gifts', { detail: cart }));
    }

    async function removeLetterTeetherLines(cart, lines = getLetterTeetherLines(cart)) {
      if (!lines.length) return false;

      const updates = {};
      lines.forEach((line) => {
        updates[line.key] = 0;
      });

      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ updates }),
      });

      if (!res.ok) {
        throw new Error(`Failed to remove letter teether gift: ${res.status}`);
      }

      return true;
    }

    async function syncLetterTeetherGiftThreshold() {
      if (!letterTeetherGiftConfig?.enabled || letterTeetherGiftSyncing) return;

      letterTeetherGiftSyncing = true;

      try {
        const cart = await fetch('/cart.js').then((r) => r.json());
        const qualifyingSubtotal = getQualifyingSubtotal(cart);
        const giftLines = getLetterTeetherGiftLines(cart);
        const invalidGiftLines = getInvalidLetterTeetherGiftLines(cart);
        let shouldRefresh = false;

        if (await enforceBogosGiftQuantity(cart)) {
          shouldRefresh = true;
        }

        if (invalidGiftLines.length) {
          acLoadingOn();
          await removeLetterTeetherLines(cart, invalidGiftLines);
          shouldRefresh = true;
        }

        if (qualifyingSubtotal < letterTeetherGiftConfig.threshold && giftLines.length) {
          acLoadingOn();
          await removeLetterTeetherLines(cart, giftLines);
          shouldRefresh = true;
        }

        triggerBogosGifts(await fetch('/cart.js').then((r) => r.json()));

        if (shouldRefresh) {
          await acUpdateContent();
        }
      } catch (err) {
        console.error('Error syncing letter teether gift threshold:', err);
      } finally {
        letterTeetherGiftSyncing = false;
        acLoadingOff();
      }
    }

    function setupBogosGiftIntegration() {
      document.addEventListener('fg-gifts:updated', () => {
        if (!acRoot?.classList.contains(acNewActiveCls)) return;
        if (acCartRefreshing || letterTeetherGiftSyncing) return;
        acUpdateContent();
      });

      document.addEventListener('fg-cart:auto-updated', () => {
        if (!acRoot?.classList.contains(acNewActiveCls)) return;
        if (acCartRefreshing || letterTeetherGiftSyncing) return;
        acUpdateContent();
      });
    }

    function setupCheckoutBogos() {
      if (acRoot.dataset.bogosCheckoutBound === 'true') return;

      acRoot.dataset.bogosCheckoutBound = 'true';
      acRoot.addEventListener('submit', async (event) => {
        const checkoutForm = event.target.closest('form[action="/cart"]');
        if (!checkoutForm || !acRoot.contains(checkoutForm)) return;
        if (event.submitter?.name !== 'checkout') return;
        if (bogosCheckoutPrepared) return;
        if (!window.BOGOS_CORE?.helper?.gift?.prepareCheckout) return;

        event.preventDefault();
        bogosCheckoutPrepared = true;

        try {
          await window.BOGOS_CORE.helper.gift.prepareCheckout();
          checkoutForm.requestSubmit(event.submitter);
        } catch (err) {
          console.error('BOGOS prepareCheckout failed:', err);
          checkoutForm.requestSubmit(event.submitter);
        } finally {
          bogosCheckoutPrepared = false;
        }
      });
    }

    setupBogosGiftIntegration();

    const acRoot = document.querySelector(`.${acNewCls}`);
    setupCheckoutBogos();
    const acCartAnchors = document.querySelectorAll('a[href^="/cart"]');
    const acProductForms = document.querySelectorAll(':not(.ac-new) form[action^="/cart/add"]');
    const headerCount = document.querySelector('#header-cart-count');
    const acAnnouncementText = acRoot.querySelector(`.${acNewAnnouncementTextCls}`);

    // Data
    const acMoneyFormat = acRoot.getAttribute('data-money-format');
    const acMoneyFormatExample = acRoot.getAttribute('data-money-format-example');
    const acCountry = acRoot.getAttribute('data-country');
    const acSectionId = acRoot.getAttribute('data-section-id') || 'ajax-cart-new';

    // State
    const acDebounceTimers = {};
    let acScrollPosition = 0;

    // Temp selectors
    let acClose,
      acMain,
      acItems,
      acFooter,
      acPairings,
      acBox,
      acRemoves,
      acLoading,
      acQuantityUps,
      acQuantityDowns,
      acDiscountCodes,
      acSubmitCodeForm,
      acSubmitCodeFormInput,
      acSubmitCodeFormButton,
      acSubmitCodeError,
      acNewGw,
      acNewGwHeader,
      acNewGwBody,
      acNewGwMinus,
      acNewGwPlus,
      acNewGwInput,
      acNewGwForm,
      acNewGn,
      acNewGnHeader,
      acNewGnBody,
      acNewGnNote;

    // Assign event listeners
    acRoot.addEventListener('click', (e) => acCloseCart());
    // acCartAnchors.forEach((el) => {
    //   el.addEventListener('click', (e) => {
    //     e.preventDefault()
    //     acOpenCart()
    //   })
    // })

    acProductForms.forEach((form) => {
      form.addEventListener('submit', (e) => acHandleAdd(e));
    });

    // Stylux cart refresh listener
    document.addEventListener('stylux:cart:refresh', (e) => {
      acUpdateContent();

      acOpenCart();
    });

    document.addEventListener('mouseup', (e) => {
      if (
        e.target.matches('.bndlr-add-to-cart') ||
        e.target.matches('.bndlr-add-bundle-to-cart') ||
        e.target.matches('.bndlr-add-sectioned-bundle-to-cart')
      ) {
        acOpenCart();

        setTimeout(() => {
          acUpdateContent();
        }, 600);

        setTimeout(() => {
          acUpdateContent();
        }, 1200);
      }
    });

    // Assign temp event listeners
    setSelectorsAndEvents();

    // Update the bundlr total
    document.addEventListener('bundler:loaded', () => {
      try {
        if (acRoot.getAttribute('data-bundle')) window.bndlr.updateCartDiscounts();
      } catch (e) {
        console.info(e);
      }
    });

    // Methods
    function setupGiftnote() {
      acNewGn = acRoot.querySelector(`.${acNewGnCls}`);

      if (acNewGn) {
        acNewGnHeader = acNewGn.querySelector(`.${acNewGnHeaderCls}`);
        acNewGnBody = acNewGn.querySelector(`.${acNewGnBodyCls}`);
        acNewGnNote = acNewGn.querySelector(`.${acNewGnNoteCls}`);

        acNewGnHeader.setAttribute('role', 'button');
        acNewGnHeader.setAttribute('tabindex', '0');
        acNewGnHeader.setAttribute('aria-expanded', 'false');

        // Slide toggle
        acNewGnHeader.addEventListener('click', () => {
          acNewGn.classList.toggle(acNewGnActiveCls);

          if (acNewGn.classList.contains(acNewGnActiveCls)) {
            acNewGnBody.style.maxHeight = acNewGnBody.scrollHeight + 'px';
            acNewGnHeader.setAttribute('aria-expanded', 'true');

            if (acMain) acMain.scrollTop = acMain.scrollHeight;
          } else {
            acNewGnBody.style.maxHeight = '0px';
            acNewGnHeader.setAttribute('aria-expanded', 'false');
          }
        });

        acNewGnHeader.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            acNewGnHeader.click();
          }
        });

        //set note
        let noteTimer;
        acNewGnNote.addEventListener('keyup', (e) => {
          clearTimeout(noteTimer);

          noteTimer = setTimeout(() => {
            const noteText = acNewGnNote.value.trim();

            fetch(`${window.Shopify.routes.root}cart/update.js`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({ note: noteText }),
            })
              .then((res) => {
                if (!res.ok) throw new Error(`Failed to update cart note: ${res.status}`);
              })
              .catch((err) => {
                console.error('Cart note update error:', err);
              });
          }, 500);
        });
      }
    }

    function setupGiftwrap() {
      acNewGw = acRoot.querySelector(`.${acNewGwCls}`);

      if (acNewGw) {
        acNewGwHeader = acNewGw.querySelector(`.${acNewGwHeaderCls}`);
        acNewGwBody = acNewGw.querySelector(`.${acNewGwBodyCls}`);
        acNewGwMinus = acNewGw.querySelector(`.${acNewGwMinusCls}`);
        acNewGwPlus = acNewGw.querySelector(`.${acNewGwPlusCls}`);
        acNewGwInput = acNewGw.querySelector(`.${acNewGwInputCls}`);
        acNewGwForm = acNewGw.querySelector(`.${acNewGwFormCls}`);

        acNewGwHeader.setAttribute('role', 'button');
        acNewGwHeader.setAttribute('tabindex', '0');
        acNewGwHeader.setAttribute('aria-expanded', 'false');

        // Slide toggle
        acNewGwHeader.addEventListener('click', () => {
          acNewGw.classList.toggle(acNewGwActiveCls);

          if (acNewGw.classList.contains(acNewGwActiveCls)) {
            acNewGwBody.style.maxHeight = acNewGwBody.scrollHeight + 'px';
            acNewGwHeader.setAttribute('aria-expanded', 'true');
            if (acMain) acMain.scrollTop = acMain.scrollHeight;
          } else {
            acNewGwBody.style.maxHeight = '0px';
            acNewGwHeader.setAttribute('aria-expanded', 'false');
          }
        });

        acNewGwHeader.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            acNewGwHeader.click();
          }
        });

        // Down
        acNewGwMinus.addEventListener('click', (e) => {
          e.preventDefault();
          let val = parseInt(acNewGwInput.value, 10) || 1;
          if (val > 1) {
            acNewGwInput.value = val - 1;
          }
        });

        // Up
        acNewGwPlus.addEventListener('click', (e) => {
          e.preventDefault();
          let val = parseInt(acNewGwInput.value, 10) || 1;
          acNewGwInput.value = val + 1;
        });

        // Add
        acNewGwForm.addEventListener('submit', async (e) => {
          e.preventDefault();
          acLoadingOn();

          const variantId = acNewGwForm.querySelector('input[name="id"]').value;
          const quantity = parseInt(acNewGwInput.value, 10) || 1;
          const productId = acNewGwForm.querySelector('input[name="product-id"]').value;

          try {
            const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                items: [
                  {
                    id: Number(variantId),
                    quantity: quantity,
                  },
                ],
              }),
            });

            if (!res.ok) {
              throw new Error(`Giftwrap add failed: ${res.status}`);
            }

            await acUpdateContent();
            acOpenCart();

            try {
              const formData = new FormData(form);
              const id = formData.get('id');
              wunderkindSDK('addToCart', { 'item:id': `${productId}` });
            } catch (err) {
              console.log('Failed to send wunderkind data', err);
            }
          } catch (err) {
            console.error('Error adding giftwrap:', err);
          } finally {
            acLoadingOff();
          }
        });
      }
    }

    function positionCartSavings() {
      const savings = acRoot.querySelector('.ac-new-footer__savings');
      const checkoutBtn = acRoot.querySelector('.ac-new-footer button[name="checkout"]');
      if (!savings || !checkoutBtn) return;
      checkoutBtn.parentNode.insertBefore(savings, checkoutBtn);
    }

    function setSelectorsAndEvents() {
      // Set selectors
      acBox = document.querySelector(`.${acNewBoxCls}`);
      acMain = acBox.querySelector(`.${acNewMainCls}`);
      acClose = acBox.querySelector(`.${acNewHeaderCloseCls}`);
      acItems = acBox.querySelector(`.${acNewItemsCls}`);
      acFooter = acBox.querySelector(`.${acNewFooterCls}`);
      acRemoves = acBox.querySelectorAll(`.${acNewRemoveCls}`);
      acPairings = acBox.querySelectorAll(`.${acNewPairingCls}`);
      acLoading = acBox.querySelector(`.${acNewLoadingCls}`);
      acQuantityUps = acBox.querySelectorAll(`.${acNewQuantityUpCls}`);
      acQuantityDowns = acBox.querySelectorAll(`.${acNewQuantityDownCls}`);
      acDiscountCodes = acBox.querySelectorAll(`.${acDiscountCodeCls}`);
      acSubmitCodeForm = acBox.querySelector(`.${acSubmitCodeFormCls}`);
      acSubmitCodeFormButton = acBox.querySelector(`.${acSubmitCodeFormButtonCls}`);
      acSubmitCodeFormInput = acBox.querySelector(`.${acSubmitCodeFormInputCls}`);
      acSubmitCodeError = acBox.querySelector(`.${acSubmitCodeFormErrorCls}`);

      // Set event listeners
      acBox.addEventListener('click', (e) => e.stopPropagation());
      acClose.addEventListener('click', (e) => acCloseCart());

      acRemoves.forEach((remove) => {
        remove.addEventListener('click', (e) => acHandleRemove(e));
      });

      acQuantityUps.forEach((up) => {
        up.addEventListener('click', (e) => acHandleQuantityChange(e, false));
      });

      acQuantityDowns.forEach((down) => {
        down.addEventListener('click', (e) => acHandleQuantityChange(e, true));
      });

      acPairings.forEach((pairing) => {
        const acPairingSelect = pairing.querySelector(`.${acNewPairingSelectCls}`);
        const acPairingForm = pairing.querySelector(`.${acNewPairingFormCls}`);

        acPairingSelect.addEventListener('change', (e) => acHandlePairingVariantChange(e, pairing));
        acPairingForm.addEventListener('submit', (e) => acHandleAdd(e));
      });

      acDiscountCodes.forEach((codeEl) => {
        const nameEl = codeEl.querySelector(`.${acDiscountCodeNameCls}`);
        const removeBtn = codeEl.querySelector(`.${acDiscountCodeRemoveCls}`);
        if (!nameEl || !removeBtn) return;

        const codeToRemove = nameEl.textContent.trim().toUpperCase();

        removeBtn.addEventListener('click', () => acRemoveDiscountCode(codeToRemove));
      });

      if (acSubmitCodeFormButton && acSubmitCodeFormInput) {
        acSubmitCodeForm.addEventListener('submit', (e) => acAddDiscountCode(e));
      }

      setupGiftwrap();
      setupGiftnote();

      positionCartSavings();
      requestAnimationFrame(positionCartSavings);
      setTimeout(positionCartSavings, 300);
      setTimeout(positionCartSavings, 1000);
    }

    async function acAddDiscountCode(e) {
      e.preventDefault();

      const newCode = acSubmitCodeFormInput.value.trim().toUpperCase();
      if (!newCode) return;

      try {
        acLoadingOn();

        // Clear previous error
        acSubmitCodeError.textContent = '';
        acSubmitCodeError.classList.remove(acSubmitCodeFormErrorActiveCls);

        // Collect existing codes from DOM
        const existingCodes = Array.from(acDiscountCodes)
          .map((el) => el.querySelector(`.${acDiscountCodeNameCls}`)?.textContent.trim().toUpperCase())
          .filter(Boolean);

        // Avoid duplicate application
        if (existingCodes.includes(newCode)) {
          acSubmitCodeError.textContent = 'Code already applied';
          acSubmitCodeError.classList.add(acSubmitCodeFormErrorActiveCls);
          acLoadingOff();
          return;
        }

        // 3. Combine and apply all codes
        const allCodes = [...existingCodes, newCode];

        const res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: allCodes.join(',') }),
        });

        const json = await res.json();

        //  Check if the new code was actually applied
        const applied = json.discount_codes?.find((d) => d.code.toUpperCase() === newCode && d.applicable);

        if (!applied) {
          acSubmitCodeError.textContent = 'Code already applied or invalid';
          acSubmitCodeError.classList.add(acSubmitCodeFormErrorActiveCls);
          acLoadingOff();
          return;
        }

        await acUpdateContent();
      } catch (err) {
        acSubmitCodeError.textContent = 'Failed to apply discount code';
        acSubmitCodeError.classList.add(acSubmitCodeFormErrorActiveCls);
        acLoadingOff();
      }
    }

    async function acRemoveDiscountCode(codeToRemove) {
      try {
        // Get remaining codes
        const remainingCodes = Array.from(acDiscountCodes)
          .map((el) => el.querySelector(`.${acDiscountCodeNameCls}`)?.textContent.trim().toUpperCase())
          .filter((code) => code && code !== codeToRemove);

        // Send the post to remove
        const res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: remainingCodes.join(',') }),
        });

        // Update ui
        await acUpdateContent();
      } catch (err) {
        console.error('Failed to update discount codes:', err);
      }
    }

    window.acOpenCart = function acOpenCart() {
      acScrollPosition = window.scrollY || document.documentElement.scrollTop;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${acScrollPosition}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      acRoot.classList.add(acNewActiveCls);
      acRoot.setAttribute('aria-hidden', 'false');
      const cartDialog = acRoot.querySelector(`.${acNewBoxCls}`);
      if (cartDialog) cartDialog.setAttribute('aria-hidden', 'false');
      const closeButton = acRoot.querySelector(`.${acNewHeaderCloseCls}`);
      if (closeButton) closeButton.focus();
    };

    function acCloseCart() {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      window.scrollTo(0, acScrollPosition);
      acRoot.classList.remove(acNewActiveCls);
      acRoot.setAttribute('aria-hidden', 'true');
      const cartDialog = acRoot.querySelector(`.${acNewBoxCls}`);
      if (cartDialog) cartDialog.setAttribute('aria-hidden', 'true');
      const cartTrigger = document.getElementById('header-cart');
      if (cartTrigger) cartTrigger.focus();
    }

    function acLoadingOn() {
      acLoading.classList.add(acNewLoadingActiveCls);
    }

    function acLoadingOff() {
      acLoading.classList.remove(acNewLoadingActiveCls);
    }

    async function acHandleQuantityChange(e, isDown) {
      e.preventDefault();

      const root = e.target.closest('.ac-new-item');
      if (root?.hasAttribute('data-letter-teether-gift')) return;

      acLoadingOn();
      const key = root.getAttribute('data-key');
      const embroideryKey = root.getAttribute('data-embroidery-key'); // same key on every embroidered row
      const selector = e.target.closest(`.${acNewSelectorCls}`);
      const input = selector.querySelector(`.${acNewSelectorInputCls}`);
      const currentValue = Number(input.value);
      let newValue = isDown ? currentValue - 1 : currentValue + 1;

      if (newValue < 0) newValue = 0;

      // Update the input right away
      input.value = newValue;

      // If there is an existing timer, clear it
      if (acDebounceTimers[key]) {
        clearTimeout(acDebounceTimers[key]);
      }

      // Start a new debounce timer
      acDebounceTimers[key] = setTimeout(async () => {
        try {
          const updates = {
            [key]: newValue,
          };

          // ──> compute the combined embroidery qty across the whole cart
          if (embroideryKey) {
            let combinedEmbQty = 0;
            document.querySelectorAll('.ac-new-item[data-has-embroidery]').forEach((item) => {
              const qtyInput = item.querySelector(`.${acNewSelectorInputCls}`);
              if (qtyInput) combinedEmbQty += Number(qtyInput.value);
            });
            updates[embroideryKey] = combinedEmbQty;
          }

          const res = await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ updates }),
          });

          if (!res.ok) {
            throw new Error(`Request failed: ${res.status}`);
          }

          // Refresh cart UI
          acUpdateContent();
        } catch (err) {
          console.error('Error updating quantity:', err);
        } finally {
          // Clean up the timer
          delete acDebounceTimers[key];
        }
      }, 400); // 400ms debounce
    }

    window.acUpdateContent = async function acUpdateContent() {
      if (acCartRefreshing) return;
      acCartRefreshing = true;

      try {
      // Check current cart for things
      const gwIsOpen = acNewGw ? acNewGw.classList.contains(acNewGwActiveCls) : false;
      const gnIsOpen = acNewGn ? acNewGn.classList.contains(acNewGnActiveCls) : false;

      // Fetch new cart section
      const html = await fetch(
        '/?section_id=' + encodeURIComponent(acSectionId) + '&country=' + acCountry
      ).then((r) => r.text());

      // Created a dom
      const dom = document.createElement('div');
      dom.innerHTML = html;

      // update cart count
      const root = dom.querySelector(`.${acNewCls}`);
      const cartCount = root.getAttribute('data-cart-count');
      headerCount.textContent = cartCount;

      // Copy announcement text
      const announcementText = root.querySelector(`.${acNewAnnouncementTextCls}`);
      if (announcementText) announcementText.innerHTML = acAnnouncementText.innerHTML;

      // International changes
      // if (acInUs) {
      //   const shippingRow = dom.querySelector(`.${acNewFooterShippingCls}`)
      //   if (shippingRow) shippingRow.classList.remove(acNewFooterShippingActiveCls)
      // } else {
      //   const progressEl = dom.querySelector(`.${acNewProgressCls}`)
      //   if (progressEl) {
      //     progressEl.remove()
      //   }
      // }

      // If the giftwrap was open open on new
      if (acNewGw && gwIsOpen) {
        const gw = dom.querySelector(`.${acNewGwCls}`);
        const gwBody = dom.querySelector(`.${acNewGwBodyCls}`);
        if (gw && gwBody) {
          gw.classList.add(acNewGwActiveCls);
          gwBody.style.maxHeight = '100px';
        }
      }

      if (acNewGn && gnIsOpen) {
        const gn = dom.querySelector(`.${acNewGnCls}`);
        const gnBody = dom.querySelector(`.${acNewGnBodyCls}`);
        if (gn && gnBody) {
          gn.classList.add(acNewGnActiveCls);
          gnBody.style.maxHeight = '120px';
        }
      }

      // Swap content
      // ─────────────────────────────────────────────
      // Preserve BOGOs progress before DOM replacement
      // ─────────────────────────────────────────────
      const existingBogosHTML = acRoot.querySelector('.ac-new-gift-progress')?.innerHTML || null;

      // Swap content
      const box = acRoot.querySelector(`.${acNewBoxCls}`);
      const newBox = dom.querySelector(`.${acNewBoxCls}`);
      if (!box || !newBox) return;

      box.innerHTML = newBox.innerHTML;

      // ─────────────────────────────────────────────
      // Restore BOGOs progress after DOM replacement
      // ─────────────────────────────────────────────
      if (existingBogosHTML) {
        const newBogosContainer = acRoot.querySelector('.ac-new-gift-progress');
        if (newBogosContainer) {
          newBogosContainer.innerHTML = existingBogosHTML;
        }
      }

      // Set new event listeners
      setSelectorsAndEvents();

      acLoadingOff();

      const latestCart = await fetch('/cart.js').then((r) => r.json());
      triggerBogosGifts(latestCart);
      await syncLetterTeetherGiftThreshold();

      // Update bundler discounts
      try {
        window.bndlr.updateCartDiscounts();
      } catch (e) {
        console.info(e);
      }

      // Send wunderkind event
      try {
        const empty = document.querySelector('.ac-new-empty');
        if (empty) wunderkindSDK('emptyCart', {});
      } catch (err) {
        console.log('Failed to send wunderkind data', err);
      }
      } finally {
        acCartRefreshing = false;
      }
    };

    async function acHandleAdd(e) {
      e.preventDefault();

      acLoadingOn();

      const form = e.target;
      const formData = new FormData(form);
      const sellingPlanId = formData.get('selling_plan');

      const submitButton = form.querySelector('button[type="submit"]');
      if (submitButton) submitButton.disabled = true;

      try {
        // --- Extract line item properties ONLY ---
        const properties = {};

        for (const [key, value] of formData.entries()) {
          if (key.startsWith('properties[') && value) {
            const propertyName = key.slice(11, -1); // properties[Name] → Name
            properties[propertyName] = value;
          }
        }

        // --- Detect embroidery based on properties ---
        const embroideryCheckbox = document.getElementById('embroidery__checkbox');
        const hasEmbroidery =
          (embroideryCheckbox && embroideryCheckbox.checked) ||
          properties['Embroidery'] === 'Yes' ||
          Boolean(properties['Embroidery Text']) ||
          Boolean(properties['Embroidery text']) ||
          Boolean(properties['Embroidery font']);

        const items = [];

        // --- Main product ---
        items.push({
          id: Number(formData.get('id')),
          quantity: 1,
          ...(sellingPlanId && { selling_plan: Number(sellingPlanId) }),
          ...(Object.keys(properties).length && { properties }),
        });

        // --- Embroidery add-on ---
        if (hasEmbroidery) {
          items.push({
            id: 40890756530242,
            quantity: 1,
          });
        }

        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items }),
        });

        if (!response.ok) {
          throw new Error(`Request failed (${response.status})`);
        }

        acOpenCart();
        acUpdateContent();

        // --- Wunderkind ---
        try {
          const productId = formData.get('product-id');
          if (productId) {
            wunderkindSDK('addToCart', { 'item:id': `${productId}` });
          }
        } catch (err) {
          console.log('Failed to send wunderkind data', err);
        }
      } catch (err) {
        console.error('Add to cart failed', err);
      } finally {
        if (submitButton) submitButton.disabled = false;
        acLoadingOff?.();
      }
    }

    async function acHandleRemove(e) {
      // Stop default
      e.preventDefault();

      // Show spinner
      acLoadingOn();

      try {
        // Get the key
        const root = e.target.closest('.ac-new-item');
        const key = root.getAttribute('data-key');

        // Remove from the dom
        root.remove();

        // Send the req
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: key,
            quantity: 0,
          }),
        });

        if (!res.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        acUpdateContent();
      } catch (err) {
        console.log(err);
      }
    }

    function acHandlePairingVariantChange(e, pairing) {
      e.preventDefault();

      try {
        const newValue = e.target.value;
        const acPairingJsonRaw = pairing.getAttribute('data-json');
        const acPairingJson = JSON.parse(acPairingJsonRaw);
        const acPairingImg = pairing.querySelector(`.${acNewPairingImgCls}`);
        const acPairingPrice = pairing.querySelector(`.${acNewPairingPriceCls}`);
        const acPairingAdd = pairing.querySelector(`.${acNewPairingAddCls}`);
        const newVariant = acPairingJson.variants.find((v) => v.id === Number(newValue));
        if (!newVariant) return;

        // Update image
        if (newVariant.featured_image) {
          acPairingImg.src = newVariant.featured_image.src + '&width=130';
        } else {
          acPairingImg.src = acPairingJson.featured_image + '&width=130';
        }

        // Update price
        const newPrice = fmoney(acMoneyFormat, acMoneyFormatExample, newVariant.price);
        acPairingPrice.textContent = newPrice;

        // Update add
        if (newVariant.available) {
          acPairingAdd.disabled = false;
          acPairingAdd.textContent = 'Add';
        } else {
          acPairingAdd.disabled = true;
          acPairingAdd.textContent = 'Unavailable';
        }
      } catch (err) {
        console.log(err);
      }
    }

    function fmoney(moneyFormatString, moneyFormatExample, cents, removeTrailingZeros = true) {
      // Calculate raw amount
      const amount = (cents / 100).toFixed(2);
      const amount_no_decimals = Math.round(cents / 100).toString();

      // Extract separators from example (e.g. "12,345,678.90" or "12.345.678,90")
      const match = moneyFormatExample.match(/(\d{2,3})([^0-9])(\d{3})([^0-9])\d{2}$/);

      let thousandsSep = ',';
      let decimalSep = '.';

      if (match) {
        thousandsSep = match[2];
        decimalSep = match[4];
      } else {
        // Fallback in case example isn't in expected form
        console.log('Could not parse moneyFormatExample, using defaults');
      }

      // Helper to format amount with correct separators
      function formatAmount(amountStr) {
        let [intPart, decPart] = amountStr.split('.');
        const intWithSep = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);

        if (removeTrailingZeros && decPart !== undefined) {
          decPart = decPart.replace(/0+$/, ''); // Remove trailing zeros
          if (decPart === '') {
            return intWithSep; // No decimal part left
          }
        }

        return decPart !== undefined ? intWithSep + decimalSep + decPart : intWithSep;
      }

      const formattedAmount = formatAmount(amount);
      const formattedAmountNoDecimals = formatAmount(amount_no_decimals);

      // Replace placeholders
      return moneyFormatString
        .replace('{{amount}}', formattedAmount)
        .replace('{{amount_no_decimals}}', formattedAmountNoDecimals);
    }

    // Bogos booster position
    try {
      Shopify.scaHandleConfigValue = {
        bogos_progressing_bar_query: '.ac-new-gift-progress',
        bogos_custom_progress_position: 'in', //before/in/after,
      };

      Shopify.reRenderCartCustom = function reRenderCartCustom() {
        acUpdateContent();
      };
    } catch (err) {}
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ajax-cart"]) return;
  try {
    
  /* ---------- Cached DOM nodes ---------- */
  const ajaxCart = document.querySelector('.ajax-cart')
  const ajaxCartBox = document.querySelector('.ajax-cart-box')

  if (!ajaxCartBox) {
    // No cart on this template – stop here.
    return
  }

  const { cartUrl, cartChangeUrl, cartAddUrl, cartUpdateUrl } = ajaxCartBox.dataset

  /* ---------- Scroll helpers ---------- */
  function lockScroll() {
    const pos = window.scrollY
    document.body.dataset.position = pos
    document.body.classList.add('lock-scroll')
    document.body.style.top = `-${pos}px`
  }

  function unlockScroll() {
    const pos = Number(document.body.dataset.position || 0)
    document.body.classList.remove('lock-scroll')
    document.body.style.top = ''
    delete document.body.dataset.position
    window.scrollTo(0, pos)
  }

  function formatMoneyL(t, e = '${{amount}}') {
    'string' == typeof t && (t = t.replace('.', ''))
    let n = /\{\{\s*(\w+)\s*\}\}/,
      o = e
    function a(t, e) {
      return void 0 === t ? e : t
    }
    function r(t, e, n, o) {
      if (((e = a(e, 2)), (n = a(n, ',')), (o = a(o, '.')), isNaN(t) || null == t)) return 0
      t = (t / 100).toFixed(e)
      let [r, m = ''] = t.split('.'),
        u = r.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + n)
      return u + (m ? o + m : '')
    }
    let m = o.match(n)[1],
      u = (
        {
          amount: () => r(t, 2),
          amount_no_decimals: () => r(t, 0),
          amount_with_comma_separator: () => r(t, 2, '.', ','),
          amount_no_decimals_with_comma_separator: () => r(t, 0, '.', ','),
        }[m] || (() => t)
      )()
    return o.replace(n, u)
  }

  /* ---------- Cart open / close ---------- */
  function openCart() {
    ajaxCart.classList.add('ajax-cart--active')
    lockScroll()
  }
  function closeCart() {
    ajaxCart.classList.remove('ajax-cart--active')
    unlockScroll()
  }

  /* ---------- Core cart refresh ---------- */
  async function updateCart() {
    if (!ajaxCartBox) return

    try {
      /* Pull fresh cart section HTML */
      const html = await fetch('/?section_id=ajax-cart').then((r) => r.text())
      const doc = new DOMParser().parseFromString(html, 'text/html')

      const newBox = doc.querySelector('.ajax-cart-box')
      const itemCount = newBox.dataset.itemCount || '0'

      /* Replace current markup */
      ajaxCart.innerHTML = newBox.outerHTML || ''

      /* Header count */
      const headerCount = document.getElementById('header-cart-count')
      if (headerCount) headerCount.textContent = itemCount

      /* Maintain scroll position inside the drawer */
      const savedY = Number(document.body.getAttribute('cart-scroll-y') || 0)
      ajaxCart.querySelector('.ajax-cart-form-flex').scrollTo(0, savedY)
      document.body.removeAttribute('cart-scroll-y')

      /* ---- Embroidery sync (unchanged logic, but with Fetch) ---- */
      const cart = await fetch('/cart.json').then((r) => r.json())
      let totalEmbroideryLines = 0
      let embroideryTotal = 0

      cart.items.forEach((item) => {
        if (item.properties && item.properties['Embroidery text']) {
          totalEmbroideryLines += item.quantity
        } else if (item.id === 40890756530242) {
          embroideryTotal += item.quantity
        }
      })

      if (totalEmbroideryLines !== embroideryTotal) {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: { 40890756530242: totalEmbroideryLines } }),
        })
      }

      /* Re-open and run bundle discount refresh if available */
      setTimeout(() => {
        openCart()
        try {
          window.bndlr.updateCartDiscounts()
        } catch (e) {
          console.info(e)
        }
      }, 10)
    } catch (err) {
      console.error('updateCart error:', err)
    }
  }

  /* ---------- Utility: delegate ---------- */
  const delegate = (eventType, selector, handler, opts) => {
    document.addEventListener(
      eventType,
      (e) => {
        const target = e.target.closest(selector)
        if (target) handler(e, target)
      },
      opts
    )
  }

  /* ---------- Event wiring ---------- */
  document.addEventListener('DOMContentLoaded', () => {
    /* Cart link opens drawer */
    delegate('click', `[href="${cartUrl}"]`, (e) => {
      e.preventDefault()
      openCart()
    })

    /* Close cart on dim-layer click or header close */
    delegate('click', '.ajax-cart', (e, overlay) => {
      const cartBox = overlay.querySelector('.ajax-cart-box')
      const closeBtn = e.target.closest('.ajax-cart-header-close')

      // Only close if clicking the overlay (outside the cart box) or on the close button
      if (!cartBox.contains(e.target) || closeBtn) {
        closeCart()
      }
    })

    /* -------- Add-to-cart form (product page) -------- */
    document.querySelectorAll('[action*="/cart/add"]').forEach((form) => {
      form.addEventListener('submit', async (e) => {
        e.preventDefault()
        const url = `${form.getAttribute('action')}.js`
        const method = form.method.toUpperCase()
        const body = new URLSearchParams(new FormData(form))

        try {
          const res = await fetch(url, {
            method,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body,
          })
          if (!res.ok) throw res
          await updateCart()
        } catch (err) {
          if (err.status === 422) {
            document.querySelector('.product-form-error').classList.remove('hidden')
          } else {
            console.error('Add-to-cart error:', err)
          }
        }
      })
    })

    /* -------- Quick-add buttons -------- */
    delegate('click', '.quick-add-button', async (e, btn) => {
      e.preventDefault()
      const id = Number(btn.getAttribute('href').split('/').pop())
      await fetch(`${cartAddUrl}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id, quantity: 1 }),
      })
      updateCart()
    })

    /* -------- Bundle buttons (outside cart) -------- */
    delegate('mouseup', '.bndlr-add-to-cart, .bndlr-add-bundle-to-cart, .bndlr-add-sectioned-bundle-to-cart', () => {
      setTimeout(updateCart, 1200)
      setTimeout(updateCart, 2000)
    })

    /* -------- Quantity + remove inside cart -------- */
    delegate('click', '.ajax-cart .quantity-selector button, .ajax-cart-item-remove', async (e, btn) => {
      e.preventDefault()
      const item = btn.closest('.ajax-cart-item')
      if (!item) return

      const id = item.dataset.lineItemKey
      const isDown = btn.classList.contains('quantity-selector-down')
      const isRemove = btn.classList.contains('ajax-cart-item-remove')
      const currentQuantity = Number(item.querySelector('.quantity-selector input').value)

      /* Remember scroll position */
      document.body.setAttribute('cart-scroll-y', ajaxCart.querySelector('.ajax-cart-form-flex').scrollTop || 0)

      if (isDown && currentQuantity === 0) return

      const quantity = isRemove ? 0 : currentQuantity + (isDown ? -1 : 1)

      await fetch(`${cartChangeUrl}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id, quantity }),
      })
      updateCart()
    })

    /* -------- Recommended products in drawer -------- */
    delegate('click', '.ajax-cart-rec .ajax-cart-rec-item-add', async (e, btn) => {
      e.preventDefault()
      const id = Number(btn.closest('.ajax-cart-rec-item').querySelector('[name="id"]').value)
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id }),
      })
      updateCart()
    })

    /* Variant dropdown in recommended products */
    delegate('change', '.ajax-cart-rec select', (e, select) => {
      const root = select.closest('.ajax-cart-rec-item')
      const productJson = JSON.parse(root.dataset.product)
      const variantId = Number(select.value)
      const variant = productJson.variants.find((v) => v.id === variantId)
      const priceElement = root.querySelector('.ajax-cart-rec-item-price')

      if (variant.featured_image) root.querySelector('img').src = variant.featured_image.src
      priceElement.textContent = formatMoneyL(variant.price).replace('.00', '')
    })

    /* -------- Gift-wrap accordion + qty -------- */
    delegate('click', '.ajax-cart-giftwrap-header', (e, hdr) => {
      hdr.nextElementSibling.classList.toggle('hidden')
      hdr.parentElement.classList.toggle('ajax-cart-giftwrap--active')
    })

    delegate('click', '.ajax-cart-giftwrap .quantity-selector button', (e, btn) => {
      const up = btn.classList.contains('quantity-selector-up')
      const input = btn.parentElement.querySelector('input')
      const current = Number(input.value)
      input.value = up ? current + 1 : Math.max(current - 1, 1)
    })

    delegate('click', '.ajax-cart-giftwrap-product-right button', async (e, btn) => {
      const root = btn.closest('.ajax-cart-giftwrap')
      const id = root.dataset.id
      const quantity = Number(root.querySelector('.quantity-selector input').value)
      await fetch(`${cartAddUrl}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id, quantity }),
      })
      updateCart()
    })

    /* -------- Gift note accordion -------- */
    delegate('click', '.ajax-cart-note-header', (e, hdr) => {
      hdr.nextElementSibling.classList.toggle('hidden')
      hdr.parentElement.classList.toggle('ajax-cart-note--active')
    })

    delegate('keyup', '.ajax-cart-note-note', (e, input) => {
      fetch(`${cartUpdateUrl}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: input.value }),
      })
    })
  })

  /* Optionally keep the 2-second auto-refresh (disabled in your source) */
  // setInterval(updateCart, 2000)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carrier-comparison"] && !Shopify.designMode) return;
  try {
    
  const table = document.querySelector('.carrier-compare-table')
  if (!table) return

  const selects = table.querySelectorAll('.carrier-compare-table__header-select')

  function updateDisabledOptions() {
    // find both active columns
    const activeCols = Array.from(table.querySelectorAll('.carrier-compare-table__column--active'))

    if (activeCols.length !== 2) return

    const [colA, colB] = activeCols
    const selA = colA.querySelector('.carrier-compare-table__header-select')
    const selB = colB.querySelector('.carrier-compare-table__header-select')

    // in select A → disable the value of select B
    Array.from(selA.options).forEach((opt) => {
      opt.disabled = opt.value === selB.value
    })

    // in select B → disable the value of select A
    Array.from(selB.options).forEach((opt) => {
      opt.disabled = opt.value === selA.value
    })
  }

  function handleSelectChange(e) {
    const select = e.target
    const column = select.closest('.carrier-compare-table__column')
    const selectedValue = select.value

    // find the real column for that product
    const targetCol = table.querySelector(`.carrier-compare-table__column[data-product="${selectedValue}"]`)
    if (!targetCol) return

    // swap: remove active from current column, add active to target column
    column.classList.remove('carrier-compare-table__column--active')
    targetCol.classList.add('carrier-compare-table__column--active')

    // reorder DOM so the swapped-in col takes the place of the old one
    table.insertBefore(targetCol, column)

    updateDisabledOptions()
  }

  selects.forEach((select) => {
    select.addEventListener('change', handleSelectChange)
  })

  updateDisabledOptions()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-variant-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Wunderkind
    try {
      const collection = document.querySelector('[data-collection-ids]');
      if (collection) {
        const ids = collection.getAttribute('data-collection-ids');
        window.wunderkindSDK('viewCategory', {
          'items:ids': ids.split(',').filter((item) => item !== ''),
          'page:url': window.location.href,
        });
      }
    } catch (err) {
      console.log('Failed to send wunderkind data', err);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faqs-new"] && !Shopify.designMode) return;
  try {
    
  const faqQuestions = document.querySelectorAll('.faq-new-question')

  faqQuestions.forEach((faq) => {
    const header = faq.querySelector('.faq-new-question__header')
    const body = faq.querySelector('.faq-new-question__body')
    const bodyInner = faq.querySelector('.faq-new-question__body-inner')

    header.addEventListener('click', function () {
      const isActive = faq.classList.contains('faq-new-question--active')

      // Close all FAQs first (if you want accordion behavior — remove this if you want multiple open)
      faqQuestions.forEach((f) => {
        f.classList.remove('faq-new-question--active')
        f.querySelector('.faq-new-question__body').style.maxHeight = '0'
      })

      if (!isActive) {
        faq.classList.add('faq-new-question--active')
        body.style.maxHeight = bodyInner.scrollHeight + 'px'
      }
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["general-faqs"] && !Shopify.designMode) return;
  try {
    
  const faqQuestions = document.querySelectorAll('.faq-new-question');

  faqQuestions.forEach((faq) => {
    const header = faq.querySelector('.faq-new-question__header');
    const body = faq.querySelector('.faq-new-question__body');
    const bodyInner = faq.querySelector('.faq-new-question__body-inner');

    header.addEventListener('click', function () {
      const isActive = faq.classList.contains('faq-new-question--active');

      // Close all FAQs first (if you want accordion behavior — remove this if you want multiple open)
      faqQuestions.forEach((f) => {
        f.classList.remove('faq-new-question--active');
        f.querySelector('.faq-new-question__body').style.maxHeight = '0';
      });

      if (!isActive) {
        faq.classList.add('faq-new-question--active');
        body.style.maxHeight = bodyInner.scrollHeight + 'px';
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-drawer"] && !Shopify.designMode) return;
  try {
    
  ;(function () {
    const drawer = document.querySelector('.gift-drawer')
    const form = document.querySelector('.gift-drawer__box')
    const closeBtn = document.querySelector('.gift-drawer__close')
    const contactFieldWrapper = document.querySelector('.gift-drawer-field--contact')
    const contactInput = document.querySelector('#contact')
    const errorP = document.querySelector('.gift-drawer__error')
    const successP = document.querySelector('.gift-drawer__success')

    if (!drawer || !form) return

    const FORMSPARK_URL = 'https://submit-form.com/I1uVyIlrS'

    /* ---------------------------
     OPEN/CLOSE HELPERS
  --------------------------- */
    function openDrawer() {
      drawer.classList.add('gift-drawer--active')
    }

    function closeDrawer() {
      drawer.classList.remove('gift-drawer--active')
    }

    /* ---------------------------
     OPEN ON .open-gift-drawer CLICK
  --------------------------- */
    document.querySelectorAll('.open-gift-drawer').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault()
        openDrawer()
      })
    })

    /* ---------------------------
     CLICK OUTSIDE → CLOSE
  --------------------------- */
    drawer.addEventListener('click', (e) => {
      if (!form.contains(e.target)) {
        closeDrawer()
      }
    })

    /* ---------------------------
     X BUTTON → CLOSE
  --------------------------- */
    closeBtn.addEventListener('click', () => {
      closeDrawer()
    })

    /* ---------------------------
     CONTACT METHOD SWITCHER
  --------------------------- */
    const contactMethodInputs = document.querySelectorAll("input[name='contact-method']")
    contactMethodInputs.forEach((input) => {
      input.addEventListener('change', (e) => {
        const value = e.target.value

        contactFieldWrapper.classList.remove('gift-drawer-field--mobile', 'gift-drawer-field--email')

        if (value === 'Mobile') {
          contactFieldWrapper.classList.add('gift-drawer-field--mobile')
        } else if (value === 'Email') {
          contactFieldWrapper.classList.add('gift-drawer-field--email')
        }
      })
    })

    /* ---------------------------
     AJAX SUBMIT → FORM SPARK
  --------------------------- */
    form.addEventListener('submit', async (e) => {
      e.preventDefault()

      // Reset success message from previous submissions
      successP.classList.remove('gift-drawer__success--active')

      // Clear old error
      errorP.textContent = ''
      errorP.classList.remove('gift-drawer__error--active')

      // Gather values
      const selectedFor = form.querySelector("input[name='for']:checked")
      const selectedAge = form.querySelector("input[name='age']:checked")
      const selectedContactMethod = form.querySelector("input[name='contact-method']:checked")
      const occasion = form.querySelector('#occasion').value
      const budget = form.querySelector("input[name='budget']:checked")?.value || ''
      const contactValue = contactInput.value.trim()
      const firstName = form.querySelector('#first_name').value.trim()
      const lastName = form.querySelector('#last_name').value.trim()

      // Validation
      if (
        !firstName ||
        !lastName ||
        !selectedFor ||
        !selectedAge ||
        !occasion ||
        !selectedContactMethod ||
        !contactValue
      ) {
        errorP.textContent = 'Please complete all required fields.'
        errorP.classList.add('gift-drawer__error--active')
        return
      }

      // Build form data
      const payload = {
        'First Name': firstName,
        'Last Name': lastName,
        'Gift For': selectedFor.value,
        'Baby Age': selectedAge.value,
        'Gifting Occasion': occasion,
        Budget: budget,
        'Contact Method': selectedContactMethod.value,
        Contact: contactValue,
      }

      try {
        const response = await fetch(FORMSPARK_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload),
        })

        if (!response.ok) {
          throw new Error('FormSpark submission failed')
        }

        /* ---------------------------
         SUCCESS → RESET + SHOW MESSAGE
      --------------------------- */
        form.reset()
        contactFieldWrapper.classList.remove('gift-drawer-field--mobile', 'gift-drawer-field--email')

        successP.classList.add('gift-drawer__success--active')
      } catch (error) {
        errorP.textContent = 'Something went wrong. Please try again.'
        errorP.classList.add('gift-drawer__error--active')
        console.error(error)
      }
    })
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  const hamburger = document.querySelector('.hamburger')
  const navDrawerPrimary = document.querySelector('.nav-drawer--primary')
  const navDrawerBundles = document.querySelector('.nav-drawer--bundles')
  const navDrawerGiftSets = document.querySelector('.nav-drawer--gift-sets')

  function setNavDrawerOpen(isOpen, manageFocus) {
    if (!navDrawerPrimary || !hamburger) return

    if (isOpen) {
      navDrawerBundles?.classList.remove('nav-drawer--active')
      navDrawerBundles?.setAttribute('aria-hidden', 'true')
      navDrawerGiftSets?.classList.remove('nav-drawer--active')
      navDrawerGiftSets?.setAttribute('aria-hidden', 'true')
    }

    navDrawerPrimary.classList.toggle('nav-drawer--active', isOpen)
    navDrawerPrimary.setAttribute('aria-hidden', isOpen ? 'false' : 'true')
    hamburger.setAttribute('aria-expanded', isOpen ? 'true' : 'false')
    setDesktopDrawerInert(navDrawerPrimary, !isOpen && isDesktopNav())

    if (!manageFocus) return

    if (isOpen) {
      const closeButton = navDrawerPrimary.querySelector('.nav-drawer__close')
      if (closeButton) closeButton.focus()
    } else {
      hamburger.focus()
    }
  }

  function isMobileNavOpen() {
    return hamburger?.getAttribute('aria-expanded') === 'true'
  }

  // Open drawer on hamburger click
  hamburger?.addEventListener('click', () => {
    setNavDrawerOpen(true, true)
  })

  // Close drawer when clicking outside the drawer content
  document.querySelectorAll('.nav-drawer').forEach((drawer) => {
    drawer.addEventListener('click', () => {
      if (drawer.classList.contains('nav-drawer--primary')) {
        setNavDrawerOpen(false, true)
      } else {
        drawer.classList.remove('nav-drawer--active')
        drawer.setAttribute('aria-hidden', 'true')
      }
    })
  })

  // Prevent closing when clicking inside the drawer content
  document.querySelectorAll('.nav-drawer__box').forEach((box) => {
    box.addEventListener('click', (e) => {
      e.stopPropagation()
    })
  })

  // Close drawer when clicking the close button
  document.querySelectorAll('.nav-drawer__close').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      const drawer = btn.closest('.nav-drawer')
      if (drawer && drawer.classList.contains('nav-drawer--primary')) {
        setNavDrawerOpen(false, true)
      } else if (drawer) {
        drawer.classList.remove('nav-drawer--active')
        drawer.setAttribute('aria-hidden', 'true')
      }
    })
  })

  document.querySelectorAll('.nav-drawer-section__header').forEach((sectionHeader) => {
    sectionHeader.addEventListener('click', (e) => {
      const section = sectionHeader.closest('.nav-drawer-section')
      const body = section.querySelector('.nav-drawer-section__body')
      const image = sectionHeader.querySelector('.nav-drawer-section__image')

      // If no body or we're on desktop (image is hidden), follow the link
      const href = sectionHeader.getAttribute('href')
      const isImageHidden = image && window.getComputedStyle(image).display === 'none'

      if (!body || isImageHidden) {
        if (href && href !== '#') {
          window.location.href = href
        }
        return
      }

      // On mobile: handle slide toggle behavior
      e.preventDefault()

      const isOpen = body.classList.contains('open')

      // Collapse all others
      document.querySelectorAll('.nav-drawer-section').forEach((sec) => {
        const bodyEl = sec.querySelector('.nav-drawer-section__body')
        if (!bodyEl) return

        sec.classList.remove('nav-drawer-section--active')
        bodyEl.style.maxHeight = '0px'
        bodyEl.classList.remove('open')
      })

      // Expand if not already open
      if (!isOpen) {
        body.style.maxHeight = body.scrollHeight + 'px'
        body.classList.add('open')
        section.classList.add('nav-drawer-section--active')
      }
    })

    sectionHeader.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter' && e.key !== ' ') return
      const section = sectionHeader.closest('.nav-drawer-section')
      const body = section?.querySelector('.nav-drawer-section__body')
      const image = sectionHeader.querySelector('.nav-drawer-section__image')
      const isImageHidden = image && window.getComputedStyle(image).display === 'none'
      if (!body || isImageHidden) return
      e.preventDefault()
      sectionHeader.click()
    })
  })

  const header = document.querySelector('.header')
  const desktopNavMq = window.matchMedia('(min-width: 1040px)')
  const headerMenuLinks = Array.from(document.querySelectorAll('.header-menu-link'))
  const shopLink =
    document.querySelector('.header-menu-link[aria-controls="nav-drawer-primary"]') ||
    headerMenuLinks.find((link) => (link.getAttribute('href') || '').includes('/collections/all-items')) ||
    null
  const bundlesLink =
    document.querySelector('.header-menu-link[aria-controls="nav-drawer-bundles"]') ||
    headerMenuLinks.find((link) => {
      const text = (link.textContent || '').trim()
      const href = link.getAttribute('href') || ''
      return text === 'Bundles' || href.includes('/collections/bundles')
    }) ||
    null
  const giftSetsLink =
    document.querySelector('.header-menu-link[aria-controls="nav-drawer-gift-sets"]') ||
    headerMenuLinks.find((link) => {
      const text = (link.textContent || '').trim().toLowerCase()
      return text === 'gift sets'
    }) ||
    null
  let megaMenuTrigger = null
  let isRoutingMegaMenuFocus = false

  function isDesktopNav() {
    return desktopNavMq.matches
  }

  function isVisibleFocusable(el, drawerBox) {
    if (!(el instanceof HTMLElement) || el.disabled) return false
    if (el.getAttribute('aria-hidden') === 'true') return false
    if (el.tabIndex < 0 && !el.matches('a[href], button, input, select, textarea')) return false
    if (el.closest('.nav-drawer-section--mobile-only, .nav-drawer__header')) return false

    let node = el
    while (node && node !== drawerBox) {
      const style = window.getComputedStyle(node)
      if (style.display === 'none') return false
      if (!isDesktopNav() || !drawerBox) {
        if (style.visibility === 'hidden') return false
      }
      node = node.parentElement
    }

    if (isDesktopNav() && drawerBox?.contains(el)) {
      return true
    }

    return el.getClientRects().length > 0
  }

  function getDrawerFocusables(drawerBox) {
    if (!drawerBox) return []

    const sectionSelector =
      '.nav-drawer-section:not(.nav-drawer-section--mobile-only) a.nav-drawer-section__header[href], .nav-drawer-section:not(.nav-drawer-section--mobile-only) .nav-drawer-section__body a[href]'
    const sectionLinks = Array.from(drawerBox.querySelectorAll(sectionSelector)).filter((el) =>
      isVisibleFocusable(el, drawerBox)
    )
    if (sectionLinks.length) return sectionLinks

    return Array.from(
      drawerBox.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled])'
      )
    ).filter((el) => isVisibleFocusable(el, drawerBox))
  }

  function focusFirstMegaMenuItem(drawer) {
    const drawerBox = drawer?.querySelector('.nav-drawer__box')
    const focusables = getDrawerFocusables(drawerBox)
    if (!focusables.length) return false

    isRoutingMegaMenuFocus = true
    focusables[0].focus()
    window.setTimeout(() => {
      isRoutingMegaMenuFocus = false
    }, 100)
    return true
  }

  function setDesktopDrawerInert(drawer, inert) {
    if (!drawer) return
    if (inert) {
      drawer.setAttribute('inert', '')
    } else {
      drawer.removeAttribute('inert')
    }
  }

  function resetMegaMenuTriggers() {
    ;[shopLink, bundlesLink, giftSetsLink].forEach((link) => {
      if (link) link.setAttribute('aria-expanded', 'false')
    })
    megaMenuTrigger = null
  }

  function openShopMegaMenu(trigger) {
    if (!isDesktopNav() || isMobileNavOpen()) return
    hideAllDrawers()
    navDrawerPrimary.classList.add('nav-drawer--active')
    navDrawerPrimary.setAttribute('aria-hidden', 'false')
    setDesktopDrawerInert(navDrawerPrimary, false)
    setDesktopDrawerInert(navDrawerBundles, true)
    setDesktopDrawerInert(navDrawerGiftSets, true)
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'true')
      megaMenuTrigger = trigger
    }
  }

  function openBundlesMegaMenu(trigger) {
    if (!isDesktopNav() || isMobileNavOpen()) return
    hideAllDrawers()
    navDrawerBundles.classList.add('nav-drawer--active')
    navDrawerBundles.setAttribute('aria-hidden', 'false')
    setDesktopDrawerInert(navDrawerBundles, false)
    setDesktopDrawerInert(navDrawerPrimary, true)
    setDesktopDrawerInert(navDrawerGiftSets, true)
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'true')
      megaMenuTrigger = trigger
    }
  }

  function openGiftSetsMegaMenu(trigger) {
    if (!isDesktopNav() || isMobileNavOpen() || !navDrawerGiftSets) return
    hideAllDrawers()
    navDrawerGiftSets.classList.add('nav-drawer--active')
    navDrawerGiftSets.setAttribute('aria-hidden', 'false')
    setDesktopDrawerInert(navDrawerGiftSets, false)
    setDesktopDrawerInert(navDrawerPrimary, true)
    setDesktopDrawerInert(navDrawerBundles, true)
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'true')
      megaMenuTrigger = trigger
    }
  }

  function hideAllDesktopMegaMenus(returnFocus) {
    if (!isMobileNavOpen()) {
      navDrawerPrimary.classList.remove('nav-drawer--active')
      navDrawerPrimary.setAttribute('aria-hidden', 'true')
      setDesktopDrawerInert(navDrawerPrimary, true)
    }
    navDrawerBundles?.classList.remove('nav-drawer--active')
    navDrawerBundles?.setAttribute('aria-hidden', 'true')
    setDesktopDrawerInert(navDrawerBundles, true)
    navDrawerGiftSets?.classList.remove('nav-drawer--active')
    navDrawerGiftSets?.setAttribute('aria-hidden', 'true')
    setDesktopDrawerInert(navDrawerGiftSets, true)
    const trigger = megaMenuTrigger
    resetMegaMenuTriggers()
    if (returnFocus && trigger) trigger.focus()
  }

  // Utility to deactivate all drawers
  function hideAllDrawers() {
    if (!isMobileNavOpen()) {
      navDrawerPrimary.classList.remove('nav-drawer--active')
      navDrawerPrimary.setAttribute('aria-hidden', 'true')
      setDesktopDrawerInert(navDrawerPrimary, true)
      resetMegaMenuTriggers()
    }
    navDrawerBundles?.classList.remove('nav-drawer--active')
    navDrawerBundles?.setAttribute('aria-hidden', 'true')
    setDesktopDrawerInert(navDrawerBundles, true)
    navDrawerGiftSets?.classList.remove('nav-drawer--active')
    navDrawerGiftSets?.setAttribute('aria-hidden', 'true')
    setDesktopDrawerInert(navDrawerGiftSets, true)
  }

  function setupMegaMenuKeyboard(trigger, drawer, openFn, nextHeaderLink) {
    if (!trigger || !drawer) return

    const drawerBox = drawer.querySelector('.nav-drawer__box')
    if (!drawerBox) return

    trigger.addEventListener('focus', () => {
      if (isDesktopNav() && !isMobileNavOpen()) openFn(trigger)
    })

    trigger.addEventListener('keydown', (e) => {
      if (!isDesktopNav() || isMobileNavOpen()) return

      if (e.key === 'Escape') {
        e.preventDefault()
        hideAllDesktopMegaMenus(true)
        return
      }

      if (e.key === 'ArrowDown' && drawer.classList.contains('nav-drawer--active')) {
        e.preventDefault()
        focusFirstMegaMenuItem(drawer)
      }
    }, true)

    drawerBox.addEventListener('keydown', (e) => {
      if (!isDesktopNav() || isMobileNavOpen() || !drawer.classList.contains('nav-drawer--active')) return

      const focusables = getDrawerFocusables(drawerBox)
      if (!focusables.length) return

      const first = focusables[0]
      const last = focusables[focusables.length - 1]

      if (e.key === 'Escape') {
        e.preventDefault()
        hideAllDesktopMegaMenus(true)
        return
      }

      if (e.key !== 'Tab') return

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault()
        trigger.focus()
        return
      }

      if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault()
        hideAllDesktopMegaMenus(false)
        if (nextHeaderLink) nextHeaderLink.focus()
      }
    })
  }

  const shopIndex = shopLink ? headerMenuLinks.indexOf(shopLink) : -1
  const bundlesIndex = bundlesLink ? headerMenuLinks.indexOf(bundlesLink) : -1
  const giftSetsIndex = giftSetsLink ? headerMenuLinks.indexOf(giftSetsLink) : -1

  setupMegaMenuKeyboard(
    shopLink,
    navDrawerPrimary,
    openShopMegaMenu,
    headerMenuLinks[shopIndex + 1]
  )
  setupMegaMenuKeyboard(
    bundlesLink,
    navDrawerBundles,
    openBundlesMegaMenu,
    headerMenuLinks[bundlesIndex + 1]
  )
  setupMegaMenuKeyboard(
    giftSetsLink,
    navDrawerGiftSets,
    openGiftSetsMegaMenu,
    headerMenuLinks[giftSetsIndex + 1]
  )

  document.addEventListener(
    'keydown',
    (e) => {
      if (e.key !== 'Tab' || e.shiftKey || !isDesktopNav() || isMobileNavOpen()) return

      const active = document.activeElement
      if (
        active === shopLink &&
        navDrawerPrimary?.classList.contains('nav-drawer--active') &&
        focusFirstMegaMenuItem(navDrawerPrimary)
      ) {
        e.preventDefault()
        return
      }

      if (
        active === bundlesLink &&
        navDrawerBundles?.classList.contains('nav-drawer--active') &&
        focusFirstMegaMenuItem(navDrawerBundles)
      ) {
        e.preventDefault()
        return
      }

      if (
        active === giftSetsLink &&
        navDrawerGiftSets?.classList.contains('nav-drawer--active') &&
        focusFirstMegaMenuItem(navDrawerGiftSets)
      ) {
        e.preventDefault()
      }
    },
    true
  )

  if (isDesktopNav()) {
    setDesktopDrawerInert(navDrawerPrimary, true)
    setDesktopDrawerInert(navDrawerBundles, true)
    setDesktopDrawerInert(navDrawerGiftSets, true)
  }

  desktopNavMq.addEventListener('change', () => {
    if (isDesktopNav()) {
      setDesktopDrawerInert(navDrawerPrimary, !navDrawerPrimary?.classList.contains('nav-drawer--active'))
      setDesktopDrawerInert(navDrawerBundles, !navDrawerBundles?.classList.contains('nav-drawer--active'))
      setDesktopDrawerInert(navDrawerGiftSets, !navDrawerGiftSets?.classList.contains('nav-drawer--active'))
    } else {
      setDesktopDrawerInert(navDrawerPrimary, false)
      setDesktopDrawerInert(navDrawerBundles, false)
      setDesktopDrawerInert(navDrawerGiftSets, false)
    }
  })

  // Show correct drawer on hover
  headerMenuLinks.forEach((link) => {
    link.addEventListener('mouseenter', () => {
      if (!isDesktopNav()) return
      const href = link.getAttribute('href')
      const controls = link.getAttribute('aria-controls')
      hideAllDrawers()

      if (href === '/collections/all-items' || controls === 'nav-drawer-primary') {
        openShopMegaMenu(link)
      } else if (controls === 'nav-drawer-bundles') {
        openBundlesMegaMenu(link)
      } else if (controls === 'nav-drawer-gift-sets') {
        openGiftSetsMegaMenu(link)
      }
    })
  })

  document.addEventListener('focusin', (e) => {
    if (!isDesktopNav() || isMobileNavOpen() || isRoutingMegaMenuFocus) return

    const target = e.target
    const shopOpen = navDrawerPrimary?.classList.contains('nav-drawer--active')
    const bundlesOpen = navDrawerBundles?.classList.contains('nav-drawer--active')
    const giftSetsOpen = navDrawerGiftSets?.classList.contains('nav-drawer--active')
    if (!shopOpen && !bundlesOpen && !giftSetsOpen) return

    const inShopContext = target === shopLink || navDrawerPrimary?.contains(target)
    const inBundlesContext = target === bundlesLink || navDrawerBundles?.contains(target)
    const inGiftSetsContext = target === giftSetsLink || navDrawerGiftSets?.contains(target)

    if (shopOpen && !inShopContext) {
      navDrawerPrimary.classList.remove('nav-drawer--active')
      navDrawerPrimary.setAttribute('aria-hidden', 'true')
      setDesktopDrawerInert(navDrawerPrimary, true)
      shopLink?.setAttribute('aria-expanded', 'false')
    }

    if (bundlesOpen && !inBundlesContext) {
      navDrawerBundles.classList.remove('nav-drawer--active')
      navDrawerBundles.setAttribute('aria-hidden', 'true')
      setDesktopDrawerInert(navDrawerBundles, true)
      bundlesLink?.setAttribute('aria-expanded', 'false')
    }

    if (giftSetsOpen && !inGiftSetsContext) {
      navDrawerGiftSets.classList.remove('nav-drawer--active')
      navDrawerGiftSets.setAttribute('aria-hidden', 'true')
      setDesktopDrawerInert(navDrawerGiftSets, true)
      giftSetsLink?.setAttribute('aria-expanded', 'false')
    }
  })

  // Hide all drawers when leaving the header
  header.addEventListener('mouseleave', () => {
    hideAllDrawers()
  })

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return
    if (isMobileNavOpen() && navDrawerPrimary?.classList.contains('nav-drawer--active')) {
      setNavDrawerOpen(false, true)
      return
    }
    if (
      isDesktopNav() &&
      (navDrawerPrimary?.classList.contains('nav-drawer--active') ||
        navDrawerBundles?.classList.contains('nav-drawer--active') ||
        navDrawerGiftSets?.classList.contains('nav-drawer--active'))
    ) {
      hideAllDesktopMegaMenus(true)
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner-slider"] && !Shopify.designMode) return;
  try {
    
  const root = document.querySelector('.hero-banner-slider .embla');
  if (!root) return;

  // Create autoplay plugin separately so we can reset it
  const autoplay = EmblaCarouselAutoplay();

  const embla = EmblaCarousel(root.querySelector('.hero-banner-slider .embla__viewport'), { loop: true }, [
    autoplay,
    EmblaCarouselFade(),
  ]);

  const prev = root.querySelector('.hero-banner-slider .embla__prev');
  const next = root.querySelector('.hero-banner-slider .embla__next');
  const playPause = root.querySelector('.hero-banner-slider .embla__playpause');

  if (playPause) {
    playPause.addEventListener('click', () => {
      const isPlaying = playPause.getAttribute('data-playing') === 'true';
      if (isPlaying) {
        autoplay.stop();
        playPause.setAttribute('data-playing', 'false');
        playPause.setAttribute('aria-label', 'Play slideshow');
      } else {
        autoplay.play();
        playPause.setAttribute('data-playing', 'true');
        playPause.setAttribute('aria-label', 'Pause slideshow');
      }
    });
  }

  prev.addEventListener('click', () => {
    embla.scrollPrev();
    autoplay.reset();
  });

  next.addEventListener('click', () => {
    embla.scrollNext();
    autoplay.reset();
  });

  const setArrowState = () => {
    prev.disabled = !embla.canScrollPrev();
    next.disabled = !embla.canScrollNext();
  };

  const dotsWrap = root.querySelector('.hero-banner-slider .embla__dots');

  const buildDots = () => {
    const slideCount = embla.slideNodes().length;

    dotsWrap.innerHTML = Array.from({ length: slideCount }, (_item, index) => {
      const isFirst = index === 0;
      const ariaSelected = isFirst ? 'true' : 'false';
      const tabIndex = isFirst ? '0' : '-1';

      return `
        <button
          class="embla__dot"
          type="button"
          role="tab"
          id="embla-tab-${index}"
          aria-controls="embla-panel-${index}"
          aria-label="Go to slide ${index + 1}"
          aria-selected="${ariaSelected}"
          tabindex="${tabIndex}"
        >
          <span class="embla__dot-inner"></span>
        </button>
      `;
    }).join('');

    dotsWrap.querySelectorAll('.hero-banner-slider .embla__dot').forEach((dot, i) => {
      dot.addEventListener('click', () => {
        embla.scrollTo(i);
        autoplay.reset();
      });
    });
  };

  const selectDot = () => {
    const selectedIndex = embla.selectedScrollSnap();
    dotsWrap.querySelectorAll('.embla__dot').forEach((dot, index) => {
      const isSelected = index === selectedIndex;
      dot.classList.toggle('is-selected', isSelected);
      dot.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      dot.setAttribute('tabindex', isSelected ? '0' : '-1');
    });
  };

  const refresh = () => {
    buildDots();
    setArrowState();
    selectDot();
  };

  embla
    .on('init', refresh)
    .on('reInit', refresh)
    .on('select', () => {
      setArrowState();
      selectDot();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"] && !Shopify.designMode) return;
  try {
    
  // Debounce helper
  function debounce(func, delay) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), delay);
    };
  }

  // --- Quantity Selectors (debounced, by item key) ---
  document.querySelectorAll('.new-cart-item:not([data-free-gift])').forEach((itemEl) => {
    const key = itemEl.dataset.key;
    const input = itemEl.querySelector('.new-cart-quantity__value');
    const btnUp = itemEl.querySelector('.new-cart-quantity__up');
    const btnDown = itemEl.querySelector('.new-cart-quantity__down');

    if (!key || !input || !btnUp || !btnDown) return;

    const updateQty = debounce(async (newQty) => {
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: key,
            quantity: newQty,
          }),
        });

        if (!res.ok) throw new Error('Cart update failed');

        const cart = await res.json();
        if (newQty === 0 && cart.item_count === 0) {
          wunderkindSDK('emptyCart', {});
        }

        location.reload(); // reload after final update
      } catch (err) {
        console.error('Error updating quantity:', err);
      }
    }, 400); // wait 400ms after last click

    btnUp.addEventListener('click', () => {
      const currentQty = parseInt(input.value, 10) || 1;
      input.value = currentQty + 1;
      updateQty(parseInt(input.value, 10));
    });

    btnDown.addEventListener('click', () => {
      const currentQty = parseInt(input.value, 10) || 1;
      const newQty = Math.max(0, currentQty - 1);
      input.value = newQty;
      updateQty(newQty);
    });
  });

  // Remove items
  document.querySelectorAll('.new-cart-item__remove').forEach((el) => {
    el.addEventListener('click', (e) => {
      const cartEl = document.querySelector('.new-cart');
      const itemCount = parseInt(cartEl?.dataset.itemCount, 10);
      const href = el.getAttribute('href');

      if (itemCount === 1 && href) {
        e.preventDefault();
        wunderkindSDK('emptyCart', {});
        setTimeout(() => {
          window.location.href = href;
        }, 500);
      }
    });
  });

  // --- Giftwrap quantity controls (local only, no AJAX) ---
  document.querySelectorAll('.new-cart-wrap').forEach((wrap) => {
    const input = wrap.querySelector('.new-cart-quantity__value');
    const up = wrap.querySelector('.new-cart-quantity__up');
    const down = wrap.querySelector('.new-cart-quantity__down');
    if (!input || !up || !down) return;

    up.addEventListener('click', () => {
      const current = parseInt(input.value, 10) || 1;
      input.value = current + 1;
    });
    down.addEventListener('click', () => {
      const current = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, current - 1);
    });
  });

  // --- Free gift selector (BOGOS slider in accordion) ---
  let freeGiftSliderMounted = false;

  function findBogosGiftSliderRoot() {
    return document.querySelector(
      '.shopify-app-block[id*="bogos_io_free_gift_gift_slider"], ' +
        '.shopify-app-block[id*="gift_slider_view"], ' +
        '#shopify-section-1783055088b10cdf0b .shopify-app-block'
    );
  }

  function triggerBogosGiftRefresh() {
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        document.dispatchEvent(new CustomEvent('bogos:cart-change', { detail: cart }));
        document.dispatchEvent(new CustomEvent('bogos:fetch-cart', { detail: cart }));
        document.dispatchEvent(new CustomEvent('bogos:gifts', { detail: cart }));
      })
      .catch(() => {});
  }

  function refreshBogosGiftSliderLayout() {
    window.dispatchEvent(new Event('resize'));

    document.querySelectorAll('.main-cart-free-gift__mount .glider').forEach((gliderEl) => {
      if (gliderEl._glider?.refresh) {
        gliderEl._glider.refresh(true);
      }
    });
  }

  function suppressBogosGiftSliderUnlessOpen() {
    const freeGiftAccordion = document.querySelector('.new-cart-free-gift');
    const isOpen = freeGiftAccordion?.classList.contains('is-open');
    const mount = document.getElementById('main-cart-bogos-gift-mount');

    document.getElementById('shopify-section-1783055088b10cdf0b')?.style.setProperty('display', 'none', 'important');

    document.querySelectorAll('.slide-container').forEach((el) => {
      const allowed = isOpen && mount?.contains(el);
      el.style.display = allowed ? '' : 'none';
    });

    document.querySelectorAll('#freegifts-main-page-container').forEach((el) => {
      const allowed = isOpen && mount?.contains(el);
      el.style.display = allowed ? '' : 'none';
    });

    document.querySelectorAll('.shopify-app-block[id*="gift_slider"]').forEach((el) => {
      const allowed = isOpen && mount?.contains(el);
      el.style.display = allowed ? '' : 'none';
    });
  }

  function mountBogosGiftSlider(forceRefresh = false) {
    const mount = document.getElementById('main-cart-bogos-gift-mount');
    if (!mount) return;

    const sliderHost = mount.querySelector('.main-cart-free-gift__slider-host');
    const bogosRoot = findBogosGiftSliderRoot();

    if (bogosRoot && !mount.contains(bogosRoot)) {
      if (sliderHost) {
        sliderHost.appendChild(bogosRoot);
      } else {
        mount.appendChild(bogosRoot);
      }
    }

    document.querySelectorAll('#freegifts-main-page-container').forEach((sliderContainer) => {
      if (sliderContainer === sliderHost || mount.contains(sliderContainer)) return;

      const target = sliderHost || mount;
      while (sliderContainer.firstChild) {
        target.appendChild(sliderContainer.firstChild);
      }
      sliderContainer.remove();
    });

    const bogosSection = document.getElementById('shopify-section-1783055088b10cdf0b');
    if (bogosSection && !bogosSection.contains(mount) && !bogosSection.querySelector('.shopify-app-block, .slide-container')) {
      bogosSection.hidden = true;
    }

    if (forceRefresh || !freeGiftSliderMounted) {
      triggerBogosGiftRefresh();
      requestAnimationFrame(() => {
        refreshBogosGiftSliderLayout();
        setTimeout(refreshBogosGiftSliderLayout, 100);
        setTimeout(refreshBogosGiftSliderLayout, 400);
      });
      freeGiftSliderMounted = true;
    }

    suppressBogosGiftSliderUnlessOpen();
  }

  suppressBogosGiftSliderUnlessOpen();

  const bogosVisibilityObserver = new MutationObserver(() => {
    suppressBogosGiftSliderUnlessOpen();
  });
  bogosVisibilityObserver.observe(document.body, { childList: true, subtree: true });

  function cartIsFreeGiftLine(item) {
    if (!item) return false;
    const props = item.properties || {};
    if (Object.keys(props).some((key) => key.toLowerCase().includes('bogos'))) return true;
    const giftHandles = ['the-letter-teether', 'the-teether'];
    if (giftHandles.includes(item.handle) && item.final_line_price === 0) return true;
    const title = `${item.product_title || ''} ${item.title || ''}`.toLowerCase();
    return title.includes('100% off');
  }

  function cartHasFreeGift(cart) {
    return cart.items.some((item) => cartIsFreeGiftLine(item));
  }

  async function enforceFreeGiftQuantity() {
    try {
      const cart = await fetch('/cart.js').then((r) => r.json());
      const overflow = cart.items.filter((item) => cartIsFreeGiftLine(item) && item.quantity > 1);
      if (!overflow.length) return;

      const updates = {};
      overflow.forEach((item) => {
        updates[item.key] = 1;
      });

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates }),
      });

      location.reload();
    } catch (err) {
      console.error('Failed to enforce free gift quantity', err);
    }
  }

  function applyFreeGiftQuantityUI() {
    document.querySelectorAll('.new-cart-item:not([data-free-gift])').forEach((row) => {
      const title = (row.querySelector('.new-cart__subheading')?.textContent || '').toLowerCase();
      const priceEl = row.querySelector('.new-cart-item__price');
      const priceText = (priceEl?.textContent || '').trim().toLowerCase();
      const isZeroPrice = priceText === '$0' || priceText === 'free' || priceText === '0';
      const isGiftLine = title.includes('100% off');

      if (!isGiftLine || !isZeroPrice) return;

      row.setAttribute('data-free-gift', '');
      row.classList.add('new-cart-item--free-gift');

      const qty = row.querySelector('.new-cart-quantity:not(.new-cart-quantity--disabled)');
      if (qty) {
        const disabled = qty.cloneNode(true);
        disabled.classList.add('new-cart-quantity--disabled');
        disabled.setAttribute('aria-label', 'Quantity: 1, fixed for free gift');
        disabled.setAttribute('title', 'Quantity is fixed for this free gift');
        const down = disabled.querySelector('.new-cart-quantity__down');
        const up = disabled.querySelector('.new-cart-quantity__up');
        const input = disabled.querySelector('.new-cart-quantity__value');
        if (down) {
          down.disabled = true;
          down.setAttribute('aria-disabled', 'true');
          down.setAttribute('aria-label', 'Decrease quantity (not available for free gifts)');
        }
        if (up) {
          up.disabled = true;
          up.setAttribute('aria-disabled', 'true');
          up.setAttribute('aria-label', 'Increase quantity (not available for free gifts)');
        }
        if (input) {
          input.value = '1';
          input.setAttribute('tabindex', '-1');
        }
        qty.replaceWith(disabled);
      }

      const topLeft = row.querySelector('.new-cart-item__main-top-left');
      if (topLeft && !topLeft.querySelector('.new-cart-item__free-gift-label')) {
        const label = document.createElement('p');
        label.className = 'new-cart-item__free-gift-label';
        label.textContent = 'Free gift';
        topLeft.appendChild(label);
      }
    });
  }

  enforceFreeGiftQuantity();
  applyFreeGiftQuantityUI();

  document.addEventListener('fg-gifts:updated', async () => {
    try {
      const cart = await fetch('/cart.js').then((r) => r.json());
      if (cartHasFreeGift(cart)) {
        document.getElementById('main-cart-free-gift')?.remove();
      }
      applyFreeGiftQuantityUI();
    } catch (err) {
      console.error('Failed to refresh free gift selector state', err);
    }
  });

  // --- Accordions ---
  const accordions = document.querySelectorAll('.new-cart-accordion');
  accordions.forEach((accordion) => {
    const header = accordion.querySelector('.new-cart-accordion__header');
    const body = accordion.querySelector('.new-cart-accordion__body');
    const isDefaultOpen = accordion.classList.contains('is-default-open');
    const isFreeGift = accordion.hasAttribute('data-free-gift-selector');
    if (isDefaultOpen) {
      if (isFreeGift) {
        mountBogosGiftSlider(true);
        body.style.maxHeight = 'none';
        body.style.overflow = 'visible';
      } else {
        body.style.maxHeight = body.scrollHeight + 'px';
        body.style.overflow = 'hidden';
      }
    }

    header.setAttribute('role', 'button');
    header.setAttribute('tabindex', '0');
    header.setAttribute('aria-expanded', accordion.classList.contains('is-open') || isDefaultOpen ? 'true' : 'false');

    header.addEventListener('click', () => {
      const isOpen = accordion.classList.contains('is-open');
      if (isOpen) {
        accordion.classList.remove('is-open');
        body.style.maxHeight = null;
        if (isFreeGift) body.style.overflow = '';
        if (isFreeGift) suppressBogosGiftSliderUnlessOpen();
        header.setAttribute('aria-expanded', 'false');
      } else {
        accordion.classList.add('is-open');
        if (isFreeGift) {
          mountBogosGiftSlider(true);
          body.style.maxHeight = 'none';
          body.style.overflow = 'visible';
        } else {
          body.style.maxHeight = body.scrollHeight + 'px';
        }
        header.setAttribute('aria-expanded', 'true');
      }
    });

    header.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        header.click();
      }
    });
  });

  // --- Gift message save ---
  const giftTextarea = document.querySelector('#giftmessage');
  const giftAccordion = giftTextarea?.closest('.new-cart-accordion');
  if (giftTextarea) {
    if (giftTextarea.value.trim().length > 0 && giftAccordion) {
      giftAccordion.classList.add('is-open');
      const body = giftAccordion.querySelector('.new-cart-accordion__body');
      if (body) body.style.maxHeight = body.scrollHeight + 'px';
    }
    let typingTimeout;
    giftTextarea.addEventListener('input', () => {
      clearTimeout(typingTimeout);
      typingTimeout = setTimeout(async () => {
        const note = giftTextarea.value.trim();
        try {
          const res = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note }),
          });
          if (!res.ok) throw new Error('Failed to save gift message');
          console.log('Gift message saved:', note);
        } catch (err) {
          console.error('Error saving gift message:', err);
        }
      }, 600);
    });
  }

  // --- Discount codes ---
  const form = document.querySelector('.new-cart-discounts__form');
  const input = document.querySelector('.new-cart-discounts__input');
  const discountList = document.querySelector('.new-cart-discounts__codes');
  const errorEl = document.querySelector('.new-cart-discounts__error');

  if (form && input) {
    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      errorEl.textContent = '';
      errorEl.classList.remove('new-cart-discounts__error--active');

      const newCode = input.value.trim();
      if (!newCode) {
        errorEl.classList.add('new-cart-discounts__error--active');
        errorEl.textContent = 'Please enter a discount code.';
        return;
      }
      const existingCodes = Array.from(discountList.querySelectorAll('.new-cart-code__name')).map((el) =>
        el.textContent.trim()
      );
      if (existingCodes.includes(newCode)) {
        errorEl.classList.add('new-cart-discounts__error--active');
        errorEl.textContent = 'That code is already applied.';
        return;
      }
      const allCodes = [...existingCodes, newCode].join(',');
      try {
        const res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: allCodes }),
        });
        if (!res.ok) throw new Error('Failed to apply code');
        const json = await res.json();
        const applied = json.discount_codes?.find(
          (d) => d.code?.toUpperCase() === newCode.toUpperCase() && d.applicable
        );
        if (!applied) {
          errorEl.classList.add('new-cart-discounts__error--active');
          errorEl.textContent = 'Invalid or expired discount code.';
          return;
        }
        location.reload();
      } catch (err) {
        console.error(err);
        errorEl.classList.add('new-cart-discounts__error--active');
        errorEl.textContent = 'Something went wrong. Please try again.';
      }
    });
  }

  // --- Remove discount codes ---
  document.querySelectorAll('.new-cart-code__remove').forEach((btn) => {
    btn.addEventListener('click', async () => {
      const discountList = document.querySelector('.new-cart-discounts__codes');
      const codeToRemove = btn.closest('.new-cart-code').querySelector('.new-cart-code__name').textContent.trim();
      const remainingCodes = Array.from(discountList.querySelectorAll('.new-cart-code__name'))
        .map((el) => el.textContent.trim())
        .filter((code) => code !== codeToRemove);
      try {
        const res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: remainingCodes.join(',') }),
        });
        if (!res.ok) throw new Error('Failed to remove code');
        location.reload();
      } catch (err) {
        console.error(err);
        const errorEl = document.querySelector('.new-cart-discounts__error');
        errorEl.classList.add('new-cart-discounts__error--active');
        errorEl.textContent = 'Error removing discount code. Please try again.';
      }
    });
  });

  // --- Embroidery quantity sync (debounced, tied to main items) ---
  async function updateCartItemQuantityByKey(key, quantity) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
      });
      if (!res.ok) throw new Error('Cart update failed');
      return await res.json();
    } catch (err) {
      console.error('Error updating embroidery quantity:', err);
    }
  }

  function syncEmbroideryQuantities() {
    const embroideryItem = document.querySelector('.new-cart-item[data-is-embroidery="true"]');
    if (!embroideryItem) return;

    const embroideryKey = embroideryItem.dataset.key;
    const productItems = document.querySelectorAll('.new-cart-item:not([data-is-embroidery="true"])');

    // debounce so we don’t spam updates
    const debouncedUpdate = debounce(async (qty) => {
      if (qty <= 0) {
        // remove embroidery entirely
        await updateCartItemQuantityByKey(embroideryKey, 0);
      } else {
        await updateCartItemQuantityByKey(embroideryKey, qty);
      }
    }, 300);

    productItems.forEach((item) => {
      const input = item.querySelector('.new-cart-quantity__value');
      const up = item.querySelector('.new-cart-quantity__up');
      const down = item.querySelector('.new-cart-quantity__down');
      if (!input || !up || !down) return;

      const syncEmbroidery = () => {
        const qty = parseInt(input.value, 10) || 0;
        debouncedUpdate(qty);
      };

      up.addEventListener('click', syncEmbroidery);
      down.addEventListener('click', syncEmbroidery);
    });
  }

  document.addEventListener('DOMContentLoaded', syncEmbroideryQuantities);

  // --- Pairings variant logic (same as Ajax cart) ---
  document.querySelectorAll('.new-cart-pair').forEach((pair) => {
    const select = pair.querySelector('.new-cart-pair__select');
    const img = pair.querySelector('.new-cart-pair__img');
    const priceEl = pair.querySelector('.new-cart-pair__price');
    const addBtn = pair.querySelector('.new-cart-pair__add');

    // Store product JSON for variant info
    const productHandle = pair.querySelector('a')?.getAttribute('href')?.split('/products/')[1];
    if (!select || !img || !priceEl || !productHandle) return;

    // Fetch full product JSON (Shopify exposes this)
    fetch(`/products/${productHandle}.js`)
      .then((res) => res.json())
      .then((product) => {
        select.addEventListener('change', (e) => {
          const variantId = parseInt(e.target.value, 10);
          const variant = product.variants.find((v) => v.id === variantId);
          if (!variant) return;

          // Update image
          if (variant.featured_image) {
            img.src = variant.featured_image.src + '&width=500';
          } else if (product.featured_image) {
            img.src = product.featured_image + '&width=500';
          }

          // Update price
          priceEl.textContent = Shopify.formatMoney(variant.price, Shopify.money_format).replace('.00', '');

          // Update availability
          if (variant.available) {
            addBtn.disabled = false;
            addBtn.textContent = 'Add';
          } else {
            addBtn.disabled = true;
            addBtn.textContent = 'Unavailable';
          }
        });
      })
      .catch((err) => console.error('Error loading product JSON:', err));
  });

  // Bogos booster position
  try {
    Shopify.scaHandleConfigValue = {
      bogos_progressing_bar_query: '.main-cart-gift-progress',
      bogos_custom_progress_position: 'in', //before/in/after,
    };
  } catch (err) {}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  ;(function () {
    // SORT BY SELECT
    const sortBy = document.getElementById('sort-by')

    if (sortBy) {
      const qp = {}

      // Preserve existing query parameters
      if (location.search.length > 1) {
        const params = location.search.substring(1).split('&')

        params.forEach((param) => {
          const [key, value] = param.split('=')
          if (key) {
            qp[decodeURIComponent(key)] = decodeURIComponent(value || '')
          }
        })
      }

      // Update sort_by query parameter on change
      sortBy.addEventListener('change', function (e) {
        qp.sort_by = e.target.value
        location.search = new URLSearchParams(qp).toString()
      })
    }

    // GRID TYPE TOGGLE
    const gridTypeButtons = document.querySelectorAll('.main-collection-grid-type')
    const grid = document.querySelector('.main-collection-grid')

    gridTypeButtons.forEach((button) => {
      button.addEventListener('click', function () {
        // Remove active state from all buttons
        gridTypeButtons.forEach((btn) => btn.classList.remove('main-collection-grid-type--active'))

        // Activate clicked button
        this.classList.add('main-collection-grid-type--active')

        // Toggle grid layout
        if (this.classList.contains('main-collection-grid-type--threes')) {
          grid?.classList.add('main-collection-grid--3')
        } else {
          grid?.classList.remove('main-collection-grid--3')
        }
      })
    })

    const form = document.querySelector('#filters')
    if (!form) return

    const applyButton = document.querySelector('.main-collection-sidebar__footer-apply')
    const clearButton = document.querySelector('.main-collection-sidebar__footer-clear')
    const isMobile = () => window.innerWidth < 800

    const sliderEl = document.getElementById('price-slider')
    const hiddenMin = document.getElementById('price-min')
    const hiddenMax = document.getElementById('price-max')
    const displayMin = document.getElementById('range-display-min')
    const displayMax = document.getElementById('range-display-max')

    const defaultMin = 0
    const defaultMax = hiddenMax ? parseInt(hiddenMax.defaultValue || '100', 10) : 100

    /* ----------------------------
     FILTER COUNT
  ---------------------------- */
    function updateFilterCount() {
      const checkedCount = form.querySelectorAll('input[type="checkbox"]:checked').length

      const minVal = parseInt(hiddenMin?.value || '0', 10)
      const maxVal = parseInt(hiddenMax?.value || '0', 10)

      const priceSelected = minVal !== defaultMin || maxVal !== defaultMax

      const totalFilters = checkedCount + (priceSelected ? 1 : 0)

      if (applyButton) {
        applyButton.innerHTML = `Apply Filters (${totalFilters})`
      }
    }

    /* ----------------------------
     APPLY / BUILD URL
  ---------------------------- */
    function buildURLFromFilters() {
      const url = new URL(window.location.href)
      const params = new URLSearchParams(url.search)

      // Remove existing filter params
      Array.from(params.keys()).forEach((key) => {
        if (key.startsWith('filter.')) {
          params.delete(key)
        }
      })

      // Add checked checkboxes
      form.querySelectorAll('input[type="checkbox"]:checked').forEach((input) => {
        params.append(input.name, input.value)
      })

      // Price filters
      const priceMin = form.querySelector('input[name="filter.v.price.gte"]')
      const priceMax = form.querySelector('input[name="filter.v.price.lte"]')

      if (priceMin && priceMin.value !== '') {
        params.set('filter.v.price.gte', priceMin.value)
      }

      if (priceMax && priceMax.value !== '') {
        params.set('filter.v.price.lte', priceMax.value)
      }

      // Search query
      const searchInput = form.querySelector('input[name="q"]')
      if (searchInput && searchInput.value) {
        params.set('q', searchInput.value)
      }

      // Preserve Shopify prefix option
      const prefix = url.searchParams.get('options[prefix]')
      if (prefix) {
        params.set('options[prefix]', prefix)
      }

      return `${window.location.pathname}?${params.toString()}`
    }

    function applyFilters() {
      window.location.href = buildURLFromFilters()
    }

    /* ----------------------------
     CHECKBOX EVENTS
  ---------------------------- */
    form.querySelectorAll('input[type="checkbox"]').forEach((input) => {
      input.addEventListener('change', function () {
        updateFilterCount()
        if (!isMobile()) {
          applyFilters()
        }
      })
    })

    /* ----------------------------
     APPLY / CLEAR BUTTONS
  ---------------------------- */
    if (applyButton) {
      applyButton.addEventListener('click', function () {
        applyFilters()
      })
    }

    if (clearButton) {
      clearButton.addEventListener('click', function () {
        form.querySelectorAll('input[type="checkbox"]').forEach((input) => {
          input.checked = false
        })

        if (sliderEl && sliderEl.noUiSlider) {
          sliderEl.noUiSlider.set([defaultMin, defaultMax])
        }

        updateFilterCount()

        if (!isMobile()) {
          applyFilters()
        }
      })
    }

    /* ----------------------------
     PRICE SLIDER
  ---------------------------- */
    if (sliderEl && hiddenMin && hiddenMax && displayMin && displayMax && window.noUiSlider) {
      const max = parseInt(sliderEl.dataset.max || hiddenMax.defaultValue || '100', 10)

      const startMin = parseInt(hiddenMin.value || defaultMin, 10)
      const startMax = parseInt(hiddenMax.value || max, 10)

      noUiSlider.create(sliderEl, {
        start: [startMin, startMax],
        connect: true,
        range: {
          min: 0,
          max: 300,
        },
        step: 1,
      })

      sliderEl.noUiSlider.on('update', function (values) {
        const min = Math.round(values[0])
        const max = Math.round(values[1])

        displayMin.textContent = min
        displayMax.textContent = max
        hiddenMin.value = min
        hiddenMax.value = max

        updateFilterCount()
      })

      sliderEl.noUiSlider.on('change', function () {
        if (!isMobile()) {
          applyFilters()
        }
      })
    }

    updateFilterCount()

    /* ----------------------------
     SORT DROPDOWN
  ---------------------------- */
    const sortSelect = document.querySelector('#sort_by')
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        const url = new URL(window.location.href)
        const params = new URLSearchParams(url.search)

        params.set('sort_by', this.value)
        window.location.href = `${window.location.pathname}?${params.toString()}`
      })
    }

    /* ----------------------------
     FILTER SIDEBAR TOGGLE
  ---------------------------- */
    const filtersToggle = document.querySelector('.main-collection-info__filters')
    const filtersSidebar = document.querySelector('.main-collection-sidebar')
    const filtersClose = document.querySelector('.main-collection-sidebar__close')

    if (filtersToggle && filtersSidebar && filtersClose) {
      filtersToggle.addEventListener('click', function (e) {
        e.preventDefault()
        filtersSidebar.classList.toggle('main-collection-sidebar--active')
      })

      filtersClose.addEventListener('click', function (e) {
        e.preventDefault()
        filtersSidebar.classList.remove('main-collection-sidebar--active')
      })
    }

    /* ----------------------------
     DROPDOWNS
  ---------------------------- */
    document.querySelectorAll('.main-collection-dropdown').forEach((dropdown) => {
      const header = dropdown.querySelector('.main-collection-dropdown__header')
      const body = dropdown.querySelector('.main-collection-dropdown__body')
      if (!header || !body) return

      dropdown.classList.add('main-collection-dropdown--active')
      body.style.maxHeight = body.scrollHeight + 'px'

      header.addEventListener('click', function () {
        const isActive = dropdown.classList.toggle('main-collection-dropdown--active')

        body.style.maxHeight = isActive ? body.scrollHeight + 'px' : '0px'
      })
    })

    // Wunderkind
    try {
      const collection = document.querySelector('[data-collection-ids]')
      if (collection) {
        const ids = collection.getAttribute('data-collection-ids')
        window.wunderkindSDK('viewCategory', {
          'items:ids': ids.split(',').filter((item) => item !== ''),
          'page:url': window.location.href,
        })
      }
    } catch (err) {
      console.log('Failed to send wunderkind data', err)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-instructions"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.instructions-video').forEach((card) => {
      const video = card.querySelector('video');
      const playBtn = card.querySelector('.instructions-video__play');
      if (!video || !playBtn) return;

      playBtn.setAttribute('role', 'button');
      playBtn.setAttribute('tabindex', '0');

      const startPlayback = () => {
        video.setAttribute('controls', 'controls');
        playBtn.style.display = 'none';
        video.setAttribute('playsinline', '');
        video.play().catch(() => {
          video.setAttribute('controls', 'controls');
        });
      };

      // Play when clicking play button
      playBtn.addEventListener('click', startPlayback);
      playBtn.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          startPlayback();
        }
      });

      // Play when clicking directly on video
      video.addEventListener('click', () => {
        if (video.paused) {
          startPlayback();
        }
      });

      // Reset overlay when paused or ended
      const resetOverlay = () => {
        if (video.ended || video.paused) {
          video.removeAttribute('controls');
          playBtn.style.display = 'flex';
        }
      };
      video.addEventListener('ended', resetOverlay);
      video.addEventListener('pause', resetOverlay);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-bundles"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('.main-product-bundles');
    if (!root) return;

    // Wunderkind – Bundle "collection" view
    try {
      const bundleRoot = document.querySelector('[data-bundle-collection-ids]');
      if (bundleRoot && window.wunderkindSDK) {
        const ids = bundleRoot.getAttribute('data-bundle-collection-ids').split(',').filter(Boolean);

        if (ids.length) {
          wunderkindSDK('viewCategory', {
            'items:ids': ids,
            'page:url': window.location.href,
          });
        }
      }
    } catch (err) {
      console.warn('[wunderkind] bundle viewCategory failed', err);
    }

    // Bundles
    const moneyFormat = root.getAttribute('data-money-format');
    const moneyFormatExample = root.getAttribute('data-money-format-example');

    function closeAllSelects() {
      document
        .querySelectorAll('.main-product-bundles-select')
        .forEach((sel) => sel.classList.remove('main-product-bundles-select--active'));
    }

    function recalcBundleTotals() {
      const selectedEls = document.querySelectorAll('.main-product-bundles-select__selected');
      const addBtn = document.querySelector('.main-product-bundles__add');
      const preorderNoticeEl = document.querySelector('.main-product-bundles__preorder-notice');
      const preorderNoticeTextEl = preorderNoticeEl?.querySelector('p');
      if (!selectedEls.length || !addBtn) return;

      const discountPercent = Number(addBtn.dataset.discountPercent || 0) / 100;
      let originalTotal = 0;
      let bundleAvailable = true;
      let bundleHasPreorder = false;
      let firstPreorderNotice = '';

      selectedEls.forEach((selected) => {
        const productData = JSON.parse(selected.dataset.product);
        const variantId = Number(selected.dataset.variantId);
        const variant = productData.variants.find((v) => v.id === variantId);
        if (!variant) return;

        originalTotal += variant.price;

        const preorderIds = (selected.dataset.preorderVariants || '')
          .split(',')
          .map((id) => id.trim())
          .filter(Boolean);
        const isPreorder = preorderIds.includes(String(variantId));

        if (!variant.available && !isPreorder) {
          bundleAvailable = false;
        }

        if (isPreorder) {
          bundleHasPreorder = true;

          if (!firstPreorderNotice) {
            const selectedPreorderBadge = selected.querySelector('.main-product-bundles-select__preorder');
            firstPreorderNotice = selectedPreorderBadge?.getAttribute('data-preorder-notice') || '';
          }
        }
      });

      const discountedTotal = Math.round(originalTotal * (1 - discountPercent));

      addBtn.querySelector('.main-product-bundles__add-price').textContent = window.formatMoneyLatest(
        moneyFormat,
        moneyFormatExample,
        discountedTotal,
        true
      );

      addBtn.querySelector('.main-product-bundles__add-compare').textContent = window.formatMoneyLatest(
        moneyFormat,
        moneyFormatExample,
        originalTotal,
        true
      );

      // 🔥 FORCE state every time
      addBtn.disabled = !bundleAvailable;
      addBtn.setAttribute('aria-disabled', String(!bundleAvailable));

      addBtn.querySelector('.main-product-bundles__add-text').textContent = bundleAvailable
        ? bundleHasPreorder
          ? 'Pre-Order Now'
          : 'Add to Cart'
        : 'Sold Out';

      if (preorderNoticeEl && preorderNoticeTextEl) {
        if (bundleHasPreorder && firstPreorderNotice) {
          preorderNoticeTextEl.textContent = firstPreorderNotice;
          preorderNoticeEl.classList.add('main-product-bundles__preorder-notice--active');
        } else {
          preorderNoticeTextEl.textContent = '';
          preorderNoticeEl.classList.remove('main-product-bundles__preorder-notice--active');
        }
      }
    }

    function readLowMap(productId) {
      const el = document.getElementById(`product-inventory-${productId}`);
      if (!el) return null;
      try {
        return JSON.parse(el.textContent || '{}');
      } catch (e) {
        console.warn('Invalid JSON in product-inventory-', productId, e);
        return null;
      }
    }

    function syncLowBadge(selectEl) {
      const productRow = selectEl.closest('.main-product-bundles__product');
      if (!productRow) return;

      const productId = productRow.dataset.productId;
      const badge = productRow.querySelector('.main-product-bundles__product-low');
      if (!productId || !badge) return;

      const selected = selectEl.querySelector('.main-product-bundles-select__selected');
      const variantId = selected?.dataset?.variantId;
      if (!variantId) return;

      const lowMap = readLowMap(productId);
      if (!lowMap) return;

      // Your JSON is keyed by strings: "123": true/false
      const isLow = Boolean(lowMap[String(variantId)]);
      badge.classList.toggle('main-product-bundles__product-low--active', isLow);
    }

    const selects = document.querySelectorAll('.main-product-bundles-select');
    if (!selects.length) return;

    document.addEventListener('click', (e) => {
      if (!e.target.closest('.main-product-bundles-select')) closeAllSelects();
    });

    selects.forEach((select) => {
      const selected = select.querySelector('.main-product-bundles-select__selected');
      const options = select.querySelectorAll(
        '.main-product-bundles-select__options .main-product-bundles-select__option'
      );

      if (!selected || !options.length) return;

      selected.addEventListener('click', (e) => {
        e.stopPropagation();
        const isOpen = select.classList.contains('main-product-bundles-select--active');
        closeAllSelects();
        if (!isOpen) select.classList.add('main-product-bundles-select--active');
      });

      options.forEach((option) => {
        option.addEventListener('click', (e) => {
          e.stopPropagation();

          const variantId = option.dataset.variantId;
          if (!variantId) return;

          // Checked state
          options.forEach((o) => o.classList.remove('main-product-bundles-select__option--checked'));
          option.classList.add('main-product-bundles-select__option--checked');

          // Update variant id
          selected.dataset.variantId = variantId;

          // Update title
          const nextTitle = option.querySelector('.main-product-bundles-select__option-title')?.textContent || '';
          const selectedTitleEl = selected.querySelector('.main-product-bundles-select__option-title');
          if (selectedTitleEl) selectedTitleEl.textContent = nextTitle;

          // Update swatch
          const newSwatchImg = option.querySelector('.main-product-bundles-select__option-swatch img');
          const selectedSwatchEl = selected.querySelector('.main-product-bundles-select__option-swatch');
          if (selectedSwatchEl) {
            selectedSwatchEl.innerHTML = newSwatchImg ? newSwatchImg.outerHTML : '';
          }

          // ✅ Update SOLD OUT badge in the selected row
          const productData = JSON.parse(selected.dataset.product);
          const variant = productData.variants.find((v) => v.id === Number(variantId));

          // ✅ Update SOLD OUT badge in the selected row (UI-driven)
          const selectedRow = selected.querySelector('.main-product-bundles-select__option');
          const existingSold = selectedRow?.querySelector('.main-product-bundles-select__sold');

          // Check if the CLICKED OPTION has a sold out badge
          const optionSold = option.querySelector('.main-product-bundles-select__sold');

          if (optionSold) {
            if (!existingSold && selectedRow) {
              const sold = document.createElement('div');
              sold.className = 'main-product-bundles-select__sold';
              sold.textContent = 'Sold out';
              selectedRow.appendChild(sold);
            }
          } else {
            if (existingSold) existingSold.remove();
          }

          // ✅ Update PREORDER badge in the selected row
          const existingPreorder = selectedRow?.querySelector('.main-product-bundles-select__preorder');
          const optionPreorder = option.querySelector('.main-product-bundles-select__preorder');

          if (optionPreorder) {
            if (!existingPreorder && selectedRow) {
              const preorder = document.createElement('div');
              preorder.className = 'main-product-bundles-select__preorder';
              preorder.textContent = 'Pre-Order';
              preorder.setAttribute(
                'data-preorder-notice',
                optionPreorder.getAttribute('data-preorder-notice') || ''
              );
              selectedRow.appendChild(preorder);
            }
            if (existingPreorder) {
              existingPreorder.setAttribute(
                'data-preorder-notice',
                optionPreorder.getAttribute('data-preorder-notice') || ''
              );
            }
            if (existingSold) existingSold.remove();
          } else if (existingPreorder) {
            existingPreorder.remove();
          }

          // ✅ Sync LITE badge into selected row
          const existingLite = selectedRow?.querySelector('.main-product-bundles-select__lite');
          const optionLite = option.querySelector('.main-product-bundles-select__lite');

          if (optionLite) {
            if (!existingLite && selectedRow) {
              const lite = document.createElement('div');
              lite.className = 'main-product-bundles-select__lite';
              lite.textContent = optionLite.textContent;
              selectedRow.appendChild(lite);
            }
          } else {
            if (existingLite) existingLite.remove();
          }

          // Update mini product image
          const img = option
            .closest('.main-product-bundles__product')
            ?.querySelector('.main-product-bundles__product-image img');

          if (img && variant?.featured_image?.src) {
            img.src = variant.featured_image.src.replace(/(\.jpg|\.png|\.webp)(\?.*)?$/, '$1?width=300');
          }

          recalcBundleTotals();
          syncLowBadge(select);

          select.classList.remove('main-product-bundles-select--active');
        });
      });
    });

    recalcBundleTotals();

    const addBtn = document.querySelector('.main-product-bundles__add');
    if (!addBtn) return;

    addBtn.addEventListener('click', async (e) => {
      e.preventDefault();
      if (addBtn.disabled) return;

      const textEl = addBtn.querySelector('.main-product-bundles__add-text');
      const originalText = textEl.textContent;

      addBtn.disabled = true;
      textEl.textContent = 'Adding';

      // --------------------------------------------------
      // 1️⃣ Build cart items + capture bundle variants ONCE
      // --------------------------------------------------
      const items = [];
      const bundleVariants = [];

      document.querySelectorAll('.main-product-bundles-select__selected').forEach((sel) => {
        const variantId = Number(sel.dataset.variantId);
        if (!variantId) return;

        items.push({ id: variantId, quantity: 1 });

        try {
          const productData = JSON.parse(sel.dataset.product);
          const variant = productData.variants.find((v) => v.id === variantId);
          if (variant) {
            bundleVariants.push({ productData, variant });
          }
        } catch (e) {
          console.warn('[bundle] invalid product JSON', e);
        }
      });

      try {
        // --------------------------------------------------
        // 2️⃣ Add all bundle items to cart
        // --------------------------------------------------
        const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });

        if (!res.ok) throw new Error('Cart add failed');

        // --------------------------------------------------
        // 3️⃣ Bundlr ENABLED
        // --------------------------------------------------
        if (window.bndlr?.getCheckoutInfo) {
          window.bndlr.getCheckoutInfo(async ({ code }) => {
            if (code) {
              const newCode = code.trim().toUpperCase();
              const existingCodes = Array.from(document.querySelectorAll('.ac-new-discount-code__name')).map((el) =>
                el.textContent.trim().toUpperCase()
              );

              if (!existingCodes.includes(newCode)) {
                await fetch('/cart/update.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                    discount: [...existingCodes, newCode].join(','),
                  }),
                });
              }
            }

            await window.acUpdateContent?.();
            window.acOpenCart?.();

            // 🔥 FIRE WUNDERKIND (AFTER EVERYTHING SUCCEEDS)
            if (window.wunderkindSDK) {
              bundleVariants.forEach(({ productData, variant }) => {
                try {
                  wunderkindSDK('addToCart', {
                    'item:id': String(productData.id),
                    'item:itemgroupid': String(productData.id),
                    'item:feedid': String(variant.id),
                    quantity: 1,
                    price: variant.price / 100,
                    currency: Shopify.currency.active,
                  });
                } catch (e) {
                  console.warn('[wunderkind] addToCart failed', e);
                }
              });
            }

            addBtn.disabled = false;
            textEl.textContent = originalText;
          });
        }
        // --------------------------------------------------
        // 4️⃣ Bundlr DISABLED
        // --------------------------------------------------
        else {
          await window.acUpdateContent?.();
          window.acOpenCart?.();

          // 🔥 FIRE WUNDERKIND
          if (window.wunderkindSDK) {
            bundleVariants.forEach(({ productData, variant }) => {
              try {
                wunderkindSDK('addToCart', { 'item:id': `${productData.id}` });
              } catch (e) {
                console.warn('[wunderkind] addToCart failed', e);
              }
            });
          }

          addBtn.disabled = false;
          textEl.textContent = originalText;
        }
      } catch (err) {
        console.error(err);
        await window.acUpdateContent?.();
        window.acOpenCart?.();
        addBtn.disabled = false;
        textEl.textContent = originalText;
      }
    });

    // Embla
    const viewport = root.querySelector('.embla__viewport');
    const thumbs = root.querySelectorAll('.main-product-new-image-thumbnail');
    const dotsContainer = root.querySelector('.embla__dots');
    const prevBtn = root.querySelector('.embla__button--prev');
    const nextBtn = root.querySelector('.embla__button--next');

    if (!viewport) return;

    const embla = EmblaCarousel(viewport, { loop: false }, [EmblaCarouselFade()]);

    // Dots
    if (dotsContainer) {
      dotsContainer.innerHTML = '';
      embla.slideNodes().forEach((_, i) => {
        const dot = document.createElement('button');
        dot.className = 'embla__dot';
        dot.type = 'button';
        dot.addEventListener('click', () => embla.scrollTo(i));
        dotsContainer.appendChild(dot);
      });
    }

    // Arrows
    if (prevBtn) {
      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        embla.scrollPrev();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        embla.scrollNext();
      });
    }

    function syncUI() {
      const index = embla.selectedScrollSnap();

      if (dotsContainer) {
        dotsContainer.querySelectorAll('.embla__dot').forEach((dot, i) => {
          dot.classList.toggle('is-selected', i === index);
        });
      }

      thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('main-product-new-image-thumbnail--active', i === index);
      });
    }

    embla.on('select', syncUI);
    syncUI();

    // Thumbnail click
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const index = Number(thumb.dataset.emblaIndex);
        if (!isNaN(index)) embla.scrollTo(index);
      });
    });

    // Accordions

    const bundleAccordions = root.querySelectorAll('.main-product-bundles__accordion');

    bundleAccordions.forEach((accordion) => {
      const header = accordion.querySelector('.main-product-bundles__accordion-header');
      const body = accordion.querySelector('.main-product-bundles__accordion-body');

      if (!header || !body) return;

      header.addEventListener('click', () => {
        const isActive = accordion.classList.contains('main-product-bundles__accordion--active');

        // Close all other accordions (optional, matches PDP behavior)
        bundleAccordions.forEach((acc) => {
          acc.classList.remove('main-product-bundles__accordion--active');
          const accBody = acc.querySelector('.main-product-bundles__accordion-body');
          if (accBody) accBody.style.maxHeight = '0';
        });

        // Toggle this accordion
        if (!isActive) {
          accordion.classList.add('main-product-bundles__accordion--active');
          body.style.maxHeight = body.scrollHeight + 'px';
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-mystery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('.main-product-new');
    if (!root) return;

    /* -----------------------------
     ACCORDIONS
  ------------------------------ */
    const accordions = root.querySelectorAll('.main-product-new-content__accordion');

    accordions.forEach((accordion) => {
      const header = accordion.querySelector('.main-product-new-content__accordion-header');
      const body = accordion.querySelector('.main-product-new-content__accordion-body');
      if (!header || !body) return;

      header.addEventListener('click', () => {
        const isActive = accordion.classList.contains('main-product-new-content__accordion--active');

        if (isActive) {
          accordion.classList.remove('main-product-new-content__accordion--active');
          body.style.maxHeight = '0px';
        } else {
          accordion.classList.add('main-product-new-content__accordion--active');
          body.style.maxHeight = body.scrollHeight + 'px';
        }
      });
    });

    /* -----------------------------
     PRODUCT JSON
  ------------------------------ */
    const productJsonEl = document.getElementById('product-json');
    if (!productJsonEl) return;

    const productData = JSON.parse(productJsonEl.textContent);
    const variants = productData.variants || [];

    /* -----------------------------
     VARIANT → ADD TO CART
     (select OR hidden input)
  ------------------------------ */
    const form = root.querySelector('form[action^="/cart/add"]');
    if (form) {
      const variantInput = form.querySelector('select[name="id"]') || form.querySelector('input[name="id"]');

      const addButton = form.querySelector('.main-product-new-content__add');

      const updateAddToCartState = (variantId) => {
        const variant = variants.find((v) => String(v.id) === String(variantId));
        if (!variant || !addButton) return;

        if (variant.available) {
          addButton.disabled = false;
          addButton.textContent = 'Add to Cart';
        } else {
          addButton.disabled = true;
          addButton.textContent = 'Out of Stock';
        }
      };

      if (variantInput) {
        // Init on load
        updateAddToCartState(variantInput.value);

        // Listen only if it's a select
        if (variantInput.tagName === 'SELECT') {
          variantInput.addEventListener('change', (e) => {
            updateAddToCartState(e.target.value);
          });
        }
      }
    }

    /* -----------------------------
     MYSTERY PRODUCT SELECT → REDIRECT
  ------------------------------ */
    const productSelect = root.querySelector('.mystery-option--product select');

    if (productSelect) {
      productSelect.addEventListener('change', (e) => {
        const targetUrl = e.target.value;
        if (!targetUrl) return;

        if (window.location.pathname !== targetUrl) {
          window.location.href = targetUrl;
        }
      });
    }

    /* -----------------------------
     PAIRS WELL WITH
  ------------------------------ */
    const pairingBlocks = root.querySelectorAll('.main-product-new-content__pairing');

    pairingBlocks.forEach((pairingBlock) => {
      const productJson = pairingBlock.dataset.json;
      if (!productJson) return;

      let pairingProduct;
      try {
        pairingProduct = JSON.parse(productJson);
      } catch (e) {
        return;
      }

      const selectEl = pairingBlock.querySelector('select[name="id"]');
      const priceEl = pairingBlock.querySelector('.main-product-new-content__pairing-main-top p');
      const imageEl = pairingBlock.querySelector('.main-product-new-content__pairing-image img');
      const addButton = pairingBlock.querySelector('button[type="submit"]');

      if (!selectEl || !priceEl || !addButton) return;

      const formatMoney = (cents) => {
        return (cents / 100).toFixed(2).replace('.00', '');
      };

      const updatePairingUI = (variantId) => {
        const variant = pairingProduct.variants.find((v) => String(v.id) === String(variantId));
        if (!variant) return;

        // Price
        priceEl.textContent = formatMoney(variant.price);

        // Image
        if (variant.featured_image) {
          imageEl.src = variant.featured_image.src + '&width=130';
          imageEl.alt = variant.featured_image.alt || pairingProduct.title;
        } else if (pairingProduct.featured_image) {
          imageEl.src = pairingProduct.featured_image.src + '&width=130';
          imageEl.alt = pairingProduct.title;
        }

        // Button
        if (variant.available) {
          addButton.disabled = false;
          addButton.textContent = 'Add';
        } else {
          addButton.disabled = true;
          addButton.textContent = 'Sold Out';
        }
      };

      // Init
      updatePairingUI(selectEl.value);

      // On change
      selectEl.addEventListener('change', (e) => {
        updatePairingUI(e.target.value);
      });
    });

    /* -----------------------------
 VARIANT → PRICE UPDATE (GLOBAL FORMATTER)
------------------------------ */

    const priceEl = root.querySelector('.main-product-new-content__price');
    const compareEl = root.querySelector('.main-product-new-content__compare');
    const variantSelect = root.querySelector('select[name="id"]');

    const moneyFormat = root.getAttribute('data-money-format');
    const moneyFormatExample = root.getAttribute('data-money-format-example');

    const updatePriceUI = (variantId) => {
      const variant = variants.find((v) => String(v.id) === String(variantId));
      if (!variant || !priceEl) return;

      // Price
      priceEl.textContent = window.formatMoneyLatest(moneyFormat, moneyFormatExample, variant.price);

      // Compare-at
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = window.formatMoneyLatest(moneyFormat, moneyFormatExample, variant.compare_at_price);

        priceEl.classList.add('main-product-new-content__price--active');
        compareEl.classList.add('main-product-new-content__compare--active');
      } else {
        compareEl.textContent = '';
        priceEl.classList.remove('main-product-new-content__price--active');
        compareEl.classList.remove('main-product-new-content__compare--active');
      }
    };

    // Init on load
    if (variantSelect) {
      updatePriceUI(variantSelect.value);

      variantSelect.addEventListener('change', (e) => {
        updatePriceUI(e.target.value);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-new-ab-test"] && !Shopify.designMode) return;
  try {
    
  // State
  let emblaInstance = null;

  // Elements
  const rootEl = document.querySelector('.main-product-new');
  const idControl = rootEl.querySelector('[name="id"]');

  const allEmblaWrappers = rootEl.querySelectorAll('.embla-wrapper');
  const swatchInputs = rootEl.querySelectorAll('.swatch__input');
  const price = rootEl.querySelector('.main-product-new-content__price');
  const compare = rootEl.querySelector('.main-product-new-content__compare');
  const selectedOptionLabels = rootEl.querySelectorAll('.main-product-new-content__option-label-selection');
  const add = rootEl.querySelector('.main-product-new-content__add');
  const quantityInput = rootEl.querySelector('.main-product-new-content__quantity-input');
  const quantityMinus = rootEl.querySelector('.main-product-new-content__quantity-btn--minus');
  const quantityPlus = rootEl.querySelector('.main-product-new-content__quantity-btn--plus');
  const pairingBlocks = document.querySelectorAll('.main-product-new-content__pairing');
  const accordions = document.querySelectorAll('.main-product-new-content__accordion');
  const allPrevBtns = document.querySelectorAll('.embla__button--prev');
  const allNextBtns = document.querySelectorAll('.embla__button--next');
  const tushbabyTooltip = rootEl.querySelector('.tushbaby-lite-tooltip');

  // Data
  const productJsonString = document.querySelector('#product-json').textContent;
  const productData = JSON.parse(productJsonString);
  const productInventoryJsonString = document.querySelector('#product-inventory').textContent;
  const productInventoryJson = JSON.parse(productInventoryJsonString);
  const variantPreorderMapString = document.querySelector('#variant-preorder-map').textContent;
  const variantPreorderMap = JSON.parse(variantPreorderMapString);
  const hiddenVariantIds = JSON.parse(document.querySelector('#hidden-variant-ids')?.textContent || '[]');
  const hiddenVariantIdSet = new Set(hiddenVariantIds.map(String));
  const ginghamHoodConfig = JSON.parse(document.querySelector('#gingham-hood-variants')?.textContent || 'null');
  const allVariantData = productData.variants || [];
  const variantData = allVariantData.filter((variant) => !hiddenVariantIdSet.has(String(variant.id)));
  const moneyFormat = rootEl.getAttribute('data-money-format');
  const moneyFormatExample = rootEl.getAttribute('data-money-format-example');
  const lowInventoryThresholdString = rootEl.getAttribute('data-low-inventory-threshold');
  const lowInventoryThreshold = lowInventoryThresholdString ? Number(lowInventoryThresholdString) : 150;
  const stickyBar = document.querySelector('.sticky-add-to-cart');
  const stickyBarTriggerPoint = 1300;
  const stickyBarSelect = document.querySelector('.sticky-add-to-cart__select');
  const stickySelect = document.querySelector('.sticky-add-to-cart__select');
  const stickyImg = document.querySelector('.sticky-add-to-cart__image img');
  const embroideryColorOptions = rootEl.querySelectorAll('.main-product-new-embroidery__color');
  const embroideryColorMapEl = document.querySelector('#embroidery-thread-colors-by-variant');
  const embroideryColorAvailabilityByVariantId = JSON.parse(embroideryColorMapEl?.textContent || '{}');

  const variantCustomFirstImages = JSON.parse(document.querySelector('#variant-custom-first-images').textContent);
  const variantUvPrintedMap = JSON.parse(document.querySelector('#variant-uv-printed-map')?.textContent || '{}');
  const embroideryToggleLabel = rootEl.querySelector('.main-product-new-embroidery-toggle__checkbox-label');
  const EMBROIDERY_TOGGLE_LABEL_DEFAULT = 'Add a name or monogram (+$12)';
  const EMBROIDERY_TOGGLE_LABEL_UV_PRINTED = 'Personalize with Premium UV Printing';

  function updateEmbroideryToggleLabel(variantId) {
    if (!embroideryToggleLabel) return;
    const isUvPrinted = Boolean(variantUvPrintedMap[String(variantId)]);
    embroideryToggleLabel.textContent = isUvPrinted
      ? EMBROIDERY_TOGGLE_LABEL_UV_PRINTED
      : EMBROIDERY_TOGGLE_LABEL_DEFAULT;
  }

  const DEFAULT_EMBROIDERY_COLORS = new Set(['black', 'silver', 'gold']);
  const EMBROIDERY_PREVIEW_COLOR_CLASSES = [
    'black',
    'silver',
    'gold',
    'pink',
    'blue',
    'black-solid',
    'silver-solid',
    'gold-solid',
    'pink-solid',
    'blue-solid',
  ];

  function embroideryColorToPreviewClass(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\s+/g, '-');
  }

  function parseEmbroideryThreadColorList(rawValue) {
    if (rawValue == null || rawValue === '') return null;

    let list = rawValue;
    if (!Array.isArray(list) && typeof list === 'object' && Array.isArray(list.value)) {
      list = list.value;
    }

    const values = Array.isArray(list)
      ? list
      : String(list)
          .split(/[,•|]/)
          .map((value) => value.trim())
          .filter(Boolean);

    return values.length ? values : null;
  }

  function getAllowedEmbroideryColorsForVariant(variantId) {
    const rawValue = embroideryColorAvailabilityByVariantId[String(variantId)];
    const values = parseEmbroideryThreadColorList(rawValue);

    if (!values) return DEFAULT_EMBROIDERY_COLORS;

    return new Set(values.map((value) => String(value).toLowerCase()));
  }

  function updateEmbroideryColorOptions(variantId) {
    if (!embroideryColorOptions.length) return;

    const allowedColors = getAllowedEmbroideryColorsForVariant(variantId);
    let firstVisibleInput = null;
    let hasCheckedVisible = false;

    embroideryColorOptions.forEach((colorOption) => {
      const input = colorOption.querySelector('input');
      if (!input) return;

      const colorName = String(input.value || '').toLowerCase();
      const isVisible = allowedColors.has(colorName);

      colorOption.style.display = isVisible ? '' : 'none';
      input.disabled = !isVisible;

      if (isVisible) {
        if (!firstVisibleInput) firstVisibleInput = input;
        if (input.checked) hasCheckedVisible = true;
      } else if (input.checked) {
        input.checked = false;
      }
    });

    if (!hasCheckedVisible && firstVisibleInput) {
      firstVisibleInput.checked = true;
      firstVisibleInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // Events
  if (quantityInput && quantityMinus && quantityPlus) {
    quantityMinus.addEventListener('click', () => {
      const current = parseInt(quantityInput.value, 10) || 1;
      if (current > 1) {
        quantityInput.value = current - 1;
      }
    });

    quantityPlus.addEventListener('click', () => {
      const current = parseInt(quantityInput.value, 10) || 1;
      quantityInput.value = current + 1;
    });
  }
  swatchInputs.forEach((input) => {
    input.addEventListener('change', () => {
      if (input.closest('[data-hood-option]')) return;

      if (ginghamHoodConfig) {
        updateHoodOptionVisibility(input.value, { resetHoodDefault: input.value === ginghamHoodConfig.colorValue });
      }

      const matchedVariant = findMatchingVariant();
      console.log('variant changed', matchedVariant);
      if (!matchedVariant) return;

      const swatches = input.closest('.main-product-new-content__option-swatches');
      const fieldset = swatches.parentElement;
      const legend = swatches.previousElementSibling;
      const label = legend.querySelector('.main-product-new-content__option-label-selection');
      const optionIndex = swatches.getAttribute('data-option-index');

      let labelText = matchedVariant[`option${Number(optionIndex) + 1}`];
      if (ginghamHoodConfig && labelText === 'SSGingham') {
        labelText = ginghamHoodConfig.colorValue;
      }
      label.textContent = labelText;

      if (idControl && idControl.value !== matchedVariant.id.toString()) {
        handleVariantChange(matchedVariant);
      }
    });
  });

  rootEl.querySelectorAll('[data-hood-option] .swatch__input').forEach((input) => {
    input.addEventListener('change', () => {
      const hoodFieldset = input.closest('[data-hood-option]');
      const hoodLabel = hoodFieldset?.querySelector('[data-hood-option-label]');
      if (hoodLabel) {
        hoodLabel.textContent =
          input.value === 'SSGingham' ? 'Gingham without hood' : 'Gingham with hood';
      }

      const matchedVariant = findMatchingVariant();
      if (!matchedVariant) return;

      if (idControl && idControl.value !== matchedVariant.id.toString()) {
        handleVariantChange(matchedVariant);
      }
    });
  });

  // Thumbnail click → scroll Embla and update active state
  document.querySelectorAll('.main-product-new-image-thumbnail').forEach((thumb) => {
    const thumbImage = thumb.querySelector('img');
    const thumbLabel = thumbImage?.getAttribute('alt') || 'View product image';

    if (!thumb.hasAttribute('role')) {
      thumb.setAttribute('role', 'button');
      thumb.setAttribute('tabindex', '0');
      thumb.setAttribute('aria-label', thumbLabel);
    }

    const activateThumbnail = () => {
      const index = parseInt(thumb.getAttribute('data-embla-index'));
      if (emblaInstance && !isNaN(index)) {
        emblaInstance.scrollTo(index);
      }

      const thumbnailGroup = thumb.closest('.main-product-new-image-thumbnails');
      thumbnailGroup.querySelectorAll('.main-product-new-image-thumbnail').forEach((el) => {
        el.classList.remove('main-product-new-image-thumbnail--active');
      });

      thumb.classList.add('main-product-new-image-thumbnail--active');
    };

    thumb.addEventListener('click', activateThumbnail);
    thumb.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        activateThumbnail();
      }
    });
  });

  // Attach arrow event listeners once on page load
  allPrevBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      if (emblaInstance) emblaInstance.scrollPrev();
    });
  });

  allNextBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      if (emblaInstance) emblaInstance.scrollNext();
    });
  });

  // Embroidery add-on price (cents) — update here if the embroidery product price changes
  const EMBROIDERY_PRICE_CENTS = 1200;

  function updatePriceWithEmbroidery(variant, isEmbroideryChecked) {
    if (!price || !variant) return;
    const addOn = isEmbroideryChecked ? EMBROIDERY_PRICE_CENTS : 0;
    const displayPrice = variant.price + addOn;
    const displayCompare = (variant.compare_at_price || 0) + addOn;

    price.textContent = formatMoney(moneyFormat, moneyFormatExample, displayPrice);
    compare.textContent = displayCompare > 0 ? formatMoney(moneyFormat, moneyFormatExample, displayCompare) : '';

    if (variant.compare_at_price > variant.price) {
      price.classList.add('main-product-new-content__price--active');
      compare.classList.add('main-product-new-content__compare--active');
    } else {
      price.classList.remove('main-product-new-content__price--active');
      compare.classList.remove('main-product-new-content__compare--active');
    }

  }

  // Helpers
  function updateActiveThumbnail(variantId) {
    const selectedIndex = emblaInstance.selectedScrollSnap();

    const activeThumbBlock = rootEl.querySelector(`.main-product-new-image-thumbnails--${variantId}`);
    if (!activeThumbBlock) return;

    const allThumbs = activeThumbBlock.querySelectorAll('.main-product-new-image-thumbnail');
    allThumbs.forEach((thumb, i) => {
      if (i === selectedIndex) {
        thumb.classList.add('main-product-new-image-thumbnail--active');
      } else {
        thumb.classList.remove('main-product-new-image-thumbnail--active');
      }
    });
  }

  function updateStickyCTA(newVariant) {
    const stickyBtn = document.querySelector('.sticky-add-to-cart button[type="submit"]');
    const label = stickyBtn?.querySelector('.sticky-add-to-cart__label');

    if (!stickyBtn || !label) return;

    const isPreorder = isVariantPreorder(newVariant);

    if (!newVariant.available && !isPreorder) {
      stickyBtn.disabled = true;
      label.textContent = 'Out of Stock';
      return;
    }

    stickyBtn.disabled = false;

    if (isPreorder) {
      label.textContent = 'Pre-Order Now';
    } else {
      label.textContent = 'Add to Cart';
    }
  }

  function isVariantPreorder(variantOrId) {
    const variantId = typeof variantOrId === 'object' ? variantOrId?.id : variantOrId;
    if (!variantId) return false;
    return Boolean(variantPreorderMap[String(variantId)]);
  }

  function handleVariantChange(newVariant) {
    if (!idControl) return;

    // 🔁 Sync swatch radios to the new variant
    const optionFields = rootEl.querySelectorAll('.main-product-new-content__option:not([data-hood-option])');

    optionFields.forEach((field, index) => {
      let value = newVariant[`option${index + 1}`];
      if (!value) return;

      if (ginghamHoodConfig && value === 'SSGingham') {
        value = ginghamHoodConfig.colorValue;
      }

      const radio = field.querySelector(`input[value="${CSS.escape(value)}"]`);
      if (radio && !radio.checked) {
        radio.checked = true;
      }

      // Update label text
      const label = field.querySelector('.main-product-new-content__option-label-selection');
      if (label) {
        label.textContent =
          ginghamHoodConfig && newVariant.option1 === 'SSGingham' && index === 0
            ? ginghamHoodConfig.colorValue
            : newVariant[`option${index + 1}`];
      }
    });

    syncHoodOptionFromVariant(newVariant);

    // Change input value
    idControl.value = newVariant.id;
    updateEmbroideryColorOptions(newVariant.id);

    // Change the url
    setUrlParam('variant', newVariant.id);

    // Update the carousel
    initEmblaForVariant(newVariant.id.toString());

    // Update thumbnails
    rootEl.querySelectorAll('.main-product-new-image-thumbnails').forEach((thumbBlock) => {
      thumbBlock.classList.remove('main-product-new-image-thumbnails--active');
    });
    const activeThumbBlock = rootEl.querySelector(`.main-product-new-image-thumbnails--${newVariant.id}`);
    if (activeThumbBlock) {
      activeThumbBlock.classList.add('main-product-new-image-thumbnails--active');

      // Set the active slide
      activeThumbBlock.querySelectorAll(`.main-product-new-image-thumbnail`).forEach((el, i) => {
        if (i == 0) {
          el.classList.add('main-product-new-image-thumbnail--active');
        } else {
          el.classList.remove('main-product-new-image-thumbnail--active');
        }
      });
    }

    // Update the price
    if (price) {
      price.textContent = formatMoney(moneyFormat, moneyFormatExample, newVariant.price);
    }
    if (compare) {
      compare.textContent = formatMoney(moneyFormat, moneyFormatExample, newVariant.compare_at_price);
    }

    if (price && compare) {
      if (newVariant.compare_at_price > newVariant.price) {
        price.classList.add('main-product-new-content__price--active');
        compare.classList.add('main-product-new-content__compare--active');
      } else {
        price.classList.remove('main-product-new-content__price--active');
        compare.classList.remove('main-product-new-content__compare--active');
      }
    }

    // Update preorder
    const preorderActiveClass = 'main-product-new-content__preorder-notice--active';

    rootEl.querySelectorAll('.main-product-new-content__preorder-notice').forEach((el) => {
      el.classList.remove(preorderActiveClass);
    });

    const preorder = rootEl.querySelector(`.main-product-new-content__preorder-notice--${newVariant.id}`);
    const isPreorder = isVariantPreorder(newVariant);

    if (isPreorder && preorder) {
      preorder.classList.add(preorderActiveClass);
    }

    // Update low inventory
    const lowInventoryEls = rootEl.querySelectorAll('.main-product-new__low-inventory');

    if (lowInventoryEls.length) {
      const manualPreorderAttr = add?.getAttribute('data-manual-preorder') || '';
      const manualPreorderVariantIds = manualPreorderAttr
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean);

      const lowInventoryActiveClass = 'main-product-new__low-inventory--active';
      const variantInventory = productInventoryJson[newVariant.id];
      const isForcePreorder = manualPreorderVariantIds.includes(newVariant.id.toString()) || isPreorder;

      lowInventoryEls.forEach((lowInventoryEl) => {
        if (!isForcePreorder && variantInventory < lowInventoryThreshold && variantInventory > 0) {
          lowInventoryEl.textContent = 'ONLY A FEW LEFT';
          lowInventoryEl.classList.add(lowInventoryActiveClass);
        } else {
          lowInventoryEl.textContent = '';
          lowInventoryEl.classList.remove(lowInventoryActiveClass);
        }
      });
    }

    function updateAccordionContent(type, variantId, defaultClass, accordionSelector) {
      // Remove all active states
      rootEl.querySelectorAll(`.main-product-new-content__${type}`).forEach((el) => {
        el.classList.remove(`main-product-new-content__${type}--active`);
      });

      // Activate variant-specific or fallback
      const variantBlock = document.querySelector(`.main-product-new-content__${type}--${variantId}`);
      if (variantBlock) {
        variantBlock.classList.add(`main-product-new-content__${type}--active`);
      } else {
        const defaultBlock = document.querySelector(`.main-product-new-content__${defaultClass}`);
        if (defaultBlock) defaultBlock.classList.add(`main-product-new-content__${type}--active`);
      }

      // Recalculate accordion height only if open
      const accordion = document.querySelector(accordionSelector);
      if (accordion && accordion.classList.contains('main-product-new-content__accordion--active')) {
        const body = accordion.querySelector('.main-product-new-content__accordion-body');
        if (body) body.style.maxHeight = body.scrollHeight + 'px';
      }
    }

    updateAccordionContent(
      'details',
      newVariant.id,
      'details--default',
      '.main-product-new-content__accordion--details'
    );
    updateAccordionContent(
      'materials',
      newVariant.id,
      'materials--default',
      '.main-product-new-content__accordion--materials'
    );
    updateAccordionContent('safety', newVariant.id, 'safety--default', '.main-product-new-content__accordion--safety');

    updateAccordionContent(
      'description',
      newVariant.id,
      'description--default',
      '.main-product-new-content__accordion--description'
    );

    // Update the add button label/state
    const addLabel = add?.querySelector('.main-product-new-content__add-label');
    if (addLabel) {
      if (isPreorder) {
        addLabel.textContent = 'Pre-Order Now';
        add.disabled = false;
      } else if (newVariant.available) {
        addLabel.textContent = 'Add to Cart';
        add.disabled = false;
      } else {
        addLabel.textContent = 'Out of Stock';
        add.disabled = true;
      }
    }

    // Update variant notes
    const noteCls = 'main-product-new-content__variant-note';
    const noteActiveCls = noteCls + '--active';
    const newNote = document.querySelector(`.${noteCls}--${newVariant.id}`);
    const oldNote = document.querySelector(`.${noteActiveCls}`);

    if (oldNote) oldNote.classList.remove(noteActiveCls);
    if (newNote) newNote.classList.add(noteActiveCls);

    // Update the embroidery image
    const embroideryWrapCls = 'main-product-new-embroidery-wrap';
    const embroideryWrap = document.querySelector(`.${embroideryWrapCls}`);

    if (embroideryWrap) {
      const embroideryWrapActiveCls = 'main-product-new-embroidery-wrap--active';
      const baseFabricCls = 'main-product-new-embroidery__fabric';
      const embroideryFabric = rootEl.querySelector(`.${baseFabricCls}--${newVariant.id}`);

      if (embroideryFabric) {
        updateEmbroideryToggleLabel(newVariant.id);

        // Display section
        document.querySelector(`.${embroideryWrapCls}`).classList.add(embroideryWrapActiveCls);

        // Display correct fabric image
        rootEl.querySelectorAll(`.${baseFabricCls}--active`).forEach((el) => {
          el.classList.remove(`${baseFabricCls}--active`);
        });
        embroideryFabric.classList.add(`${baseFabricCls}--active`);
      } else {
        // Hide section
        document.querySelector(`.${embroideryWrapCls}`).classList.remove(embroideryWrapActiveCls);
        document.querySelector('.main-product-new-embroidery').classList.remove('main-product-new-embroidery--active');

        // Hide embroidery-specific thumbnails
        document.querySelectorAll('[data-embroidery-thumb]').forEach((el) => {
          el.style.display = 'none';
        });

        // Untick toggle
        document.querySelector(`.main-product-new-embroidery-toggle__checkbox`).checked = false;

        document.querySelectorAll('.main-product-new-embroidery__font input').forEach((input) => {
          input.removeAttribute('name');
        });

        document.querySelectorAll('.main-product-new-embroidery__color input').forEach((input) => {
          input.removeAttribute('name');
        });

        document.getElementById('embroidery-text').removeAttribute('name');
      }
    }

    // Update tooltip
    if (tushbabyTooltip) {
      if (newVariant.id === 40092713287746) {
        tushbabyTooltip.classList.add('tushbaby-lite-tooltip--active');
      } else {
        tushbabyTooltip.classList.remove('tushbaby-lite-tooltip--active');
      }
    }

    // Send variant wunderkind event
    try {
      const variant = findMatchingVariant();

      // wunderkindSDK('viewItem', {
      //   'item:id': `item-${productData.id}`,
      //   'item:itemgroupid': `group-item-${productData.id}`,
      // })

      wunderkindSDK('selectItem', {
        'item:id': `${productData.id}`,
        'item:itemgroupid': `${productData.id}`,
        'item:feedid': `${variant.id}`,
      });
    } catch (err) {
      console.log('Failed to send wunderkind:', err);
    }

    // Sticky bar stuff
    try {
      if (stickySelect && stickySelect.value !== newVariant.id.toString()) {
        stickySelect.value = newVariant.id;
      }

      if (stickyImg) {
        let imgSrc = null;

        // 1) Variant featured image (Shopify JSON usually gives { src })
        if (newVariant.featured_image?.src) {
          imgSrc = newVariant.featured_image.src + '&width=300';
        } else if (typeof newVariant.featured_image === 'string') {
          imgSrc = newVariant.featured_image + '&width=300';
        }

        // 2) Fallback: first custom metafield image for that variant (from our JSON map)
        if (!imgSrc) {
          const custom = variantCustomFirstImages?.[newVariant.id];
          if (custom) imgSrc = custom; // already has width=300
        }

        // 3) Fallback: product featured image
        if (!imgSrc && productData.featured_image) {
          imgSrc = 'https:' + productData.featured_image + '&width=300';
        }

        if (imgSrc) {
          stickyImg.src = imgSrc;
          stickyImg.alt = newVariant.title || productData.title;
        }
      }

      updateStickyCTA(newVariant);
    } catch (err) {}
  }

  function initEmblaForVariant(variantId) {
    // Hide all Embla wrappers
    allEmblaWrappers.forEach((wrapper) => {
      wrapper.style.display = wrapper.dataset.variantId === variantId ? 'block' : 'none';
    });

    // Destroy previous instance
    if (emblaInstance) emblaInstance.destroy();

    // Find the correct viewport
    const targetWrapper = document.querySelector(`.embla-wrapper[data-variant-id="${variantId}"]`);
    const viewport = targetWrapper.querySelector('.embla__viewport');

    if (viewport) {
      requestAnimationFrame(() => {
        emblaInstance = EmblaCarousel(viewport, { loop: false }, [EmblaCarouselFade()]);

        // Setup dots
        const dotsContainer = targetWrapper.querySelector('.embla__dots');
        const slideCount = emblaInstance.slideNodes().length;
        dotsContainer.innerHTML = ''; // Clear previous dots

        for (let i = 0; i < slideCount; i++) {
          const dot = document.createElement('button');
          dot.classList.add('embla__dot');
          dot.type = 'button';
          dot.addEventListener('click', () => emblaInstance.scrollTo(i));
          dotsContainer.appendChild(dot);
        }

        function updateUI() {
          const selectedIndex = emblaInstance.selectedScrollSnap();

          // Update thumbnails
          const activeThumbBlock = rootEl.querySelector(`.main-product-new-image-thumbnails--${variantId}`);
          if (activeThumbBlock) {
            const allThumbs = activeThumbBlock.querySelectorAll('.main-product-new-image-thumbnail');
            allThumbs.forEach((thumb, i) => {
              thumb.classList.toggle('main-product-new-image-thumbnail--active', i === selectedIndex);
            });
          }

          // Update dots
          const allDots = dotsContainer.querySelectorAll('.embla__dot');
          allDots.forEach((dot, i) => {
            dot.classList.toggle('is-selected', i === selectedIndex);
          });

          // 🎥 Autoplay video in active slide
          const allSlides = emblaInstance.slideNodes();
          allSlides.forEach((slide, i) => {
            const video = slide.querySelector('video');
            if (video) {
              if (i === selectedIndex) {
                video.muted = true; // required for autoplay in most browsers
                video.loop = true;
                video.play().catch(() => {}); // prevent errors if not allowed
              } else {
                video.pause();
                video.currentTime = 0; // reset if you want it to start fresh
              }
            }
          });
        }

        emblaInstance.on('select', updateUI);
        updateUI();
      });
    }
  }

  function getHoodOptionValue() {
    const hoodFieldset = rootEl.querySelector('[data-hood-option]');
    if (!hoodFieldset || hoodFieldset.hidden) return null;

    const checked = hoodFieldset.querySelector('input:checked');
    return checked ? checked.value : null;
  }

  function updateHoodOptionVisibility(colorValue, options = {}) {
    const hoodFieldset = rootEl.querySelector('[data-hood-option]');
    if (!hoodFieldset || !ginghamHoodConfig) return;

    const isGingham = colorValue === ginghamHoodConfig.colorValue;
    hoodFieldset.classList.toggle('main-product-new-content__hood-option--visible', isGingham);

    if (isGingham) {
      hoodFieldset.hidden = false;
      hoodFieldset.removeAttribute('hidden');
    } else {
      hoodFieldset.hidden = true;
    }

    if (!isGingham) return;

    if (options.resetHoodDefault) {
      const withHoodRadio = hoodFieldset.querySelector('input[value="Gingham"]');
      const hoodLabel = hoodFieldset.querySelector('[data-hood-option-label]');
      if (withHoodRadio) withHoodRadio.checked = true;
      if (hoodLabel) hoodLabel.textContent = 'Gingham with hood';
    }
  }

  function syncHoodOptionFromVariant(newVariant) {
    const hoodFieldset = rootEl.querySelector('[data-hood-option]');
    if (!hoodFieldset || !ginghamHoodConfig) return;

    const isGinghamFamily = newVariant.option1 === 'Gingham' || newVariant.option1 === 'SSGingham';
    updateHoodOptionVisibility(isGinghamFamily ? ginghamHoodConfig.colorValue : newVariant.option1);

    if (!isGinghamFamily) return;

    const hoodValue = newVariant.option1 === 'SSGingham' ? 'SSGingham' : 'Gingham';
    const radio = hoodFieldset.querySelector(`input[value="${CSS.escape(hoodValue)}"]`);
    if (radio && !radio.checked) {
      radio.checked = true;
    }

    const hoodLabel = hoodFieldset.querySelector('[data-hood-option-label]');
    if (hoodLabel) {
      hoodLabel.textContent =
        hoodValue === 'SSGingham' ? 'Gingham without hood' : 'Gingham with hood';
    }
  }

  function findMatchingVariant() {
    const optionFields = rootEl.querySelectorAll('.main-product-new-content__option:not([data-hood-option])');
    const selectedValues = [];

    optionFields.forEach((field, i) => {
      const checked = field.querySelector('input:checked');
      if (!checked) return;

      let val = checked.value;
      if (ginghamHoodConfig && val === ginghamHoodConfig.colorValue) {
        const hoodValue = getHoodOptionValue();
        if (hoodValue === 'SSGingham') {
          val = 'SSGingham';
        }
      }

      selectedValues[i] = val;
    });

    return allVariantData.find((variant) => {
      return selectedValues.every((val, i) => variant[`option${i + 1}`] === val);
    });
  }

  // Pairings
  pairingBlocks.forEach((pairingBlock) => {
    // Parse pairing product JSON
    const productData = JSON.parse(pairingBlock.dataset.json);

    const selectEl = pairingBlock.querySelector('select[name="id"]');
    const priceEl = pairingBlock.querySelector('.main-product-new-content__pairing-main-top p');
    const imageEl = pairingBlock.querySelector('.main-product-new-content__pairing-image img');
    const addButton = pairingBlock.querySelector('button[type="submit"]');

    const updatePairingUI = (variantId) => {
      const variant = productData.variants.find((v) => v.id == Number(variantId));
      if (!variant) return;

      // Update price
      priceEl.textContent = formatMoney(moneyFormat, moneyFormatExample, variant.price).replace('.00', '');

      if (variant.featured_image) {
        imageEl.src = variant.featured_image.src + '&width=130';
        imageEl.alt = variant.featured_image.alt || productData.title;
      } else if (productData.featured_image) {
        imageEl.src = productData.featured_image.src + '&width=130';
        imageEl.alt = productData.featured_image.alt || productData.title;
      }

      // Update add button (disabled if out of stock)
      if (variant.available) {
        addButton.disabled = false;
        addButton.textContent = 'Add';
      } else {
        addButton.disabled = true;
        addButton.textContent = 'Sold Out';
      }
    };

    // On select change
    selectEl.addEventListener('change', (e) => {
      updatePairingUI(e.target.value);
    });
  });

  // Accordions
  accordions.forEach((accordion, accordionIndex) => {
    const header = accordion.querySelector('.main-product-new-content__accordion-header');
    const body = accordion.querySelector('.main-product-new-content__accordion-body');
    const heading = header?.querySelector('h3');
    const bodyId = `product-accordion-body-${accordionIndex}`;

    if (!header || !body) return;

    body.id = bodyId;
    header.setAttribute('role', 'button');
    header.setAttribute('tabindex', '0');
    header.setAttribute('aria-expanded', accordion.classList.contains('main-product-new-content__accordion--active') ? 'true' : 'false');
    header.setAttribute('aria-controls', bodyId);
    if (heading) header.setAttribute('aria-label', heading.textContent.trim());

    const toggleAccordion = () => {
      const isActive = accordion.classList.contains('main-product-new-content__accordion--active');

      if (isActive) {
        accordion.classList.remove('main-product-new-content__accordion--active');
        body.style.maxHeight = '0';
        header.setAttribute('aria-expanded', 'false');
      } else {
        accordion.classList.add('main-product-new-content__accordion--active');
        body.style.maxHeight = body.scrollHeight + 'px';
        header.setAttribute('aria-expanded', 'true');
      }
    };

    header.addEventListener('click', toggleAccordion);
    header.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggleAccordion();
      }
    });
  });

  // Open first accordion on load when setting is enabled
  const accordionsWrapper = document.querySelector(
    '.main-product-new-content__accordions-wrapper[data-open-first-on-load="true"]'
  );
  if (accordionsWrapper) {
    const firstAccordion = accordionsWrapper.querySelector('.main-product-new-content__accordion');
    if (firstAccordion) {
      const body = firstAccordion.querySelector('.main-product-new-content__accordion-body');
      const header = firstAccordion.querySelector('.main-product-new-content__accordion-header');
      firstAccordion.classList.add('main-product-new-content__accordion--active');
      if (body) body.style.maxHeight = body.scrollHeight + 'px';
      if (header) header.setAttribute('aria-expanded', 'true');
    }
  }

  // Embroidery
  const embroidery = document.querySelector('.main-product-new-embroidery');

  if (embroidery && idControl) {
    const embroideryActiveCls = 'main-product-new-embroidery--active';
    const embroideryToggle = document.querySelector('#embroidery__checkbox');

    if (embroideryToggle) {
      embroideryToggle.addEventListener('change', (e) => {
        const isChecked = e.target.checked;
        if (isChecked) {
          embroidery.classList.add(embroideryActiveCls);

          document.querySelectorAll('[data-embroidery-thumb]').forEach((el) => {
            el.style.display = 'block';
          });

          document.querySelectorAll('.main-product-new-embroidery__font input').forEach((input) => {
            input.setAttribute('name', 'properties[Embroidery font]');
          });

          document.querySelectorAll('.main-product-new-embroidery__color input').forEach((input) => {
            input.setAttribute('name', 'properties[Embroidery color]');
          });

          document.getElementById('embroidery-text').setAttribute('name', 'properties[Embroidery text]');
        } else {
          embroidery.classList.remove(embroideryActiveCls);

          document.querySelectorAll('[data-embroidery-thumb]').forEach((el) => {
            el.style.display = 'none';
          });

          document.querySelectorAll('.main-product-new-embroidery__font input').forEach((input) => {
            input.removeAttribute('name');
          });

          document.querySelectorAll('.main-product-new-embroidery__color input').forEach((input) => {
            input.removeAttribute('name');
          });

          document.getElementById('embroidery-text').removeAttribute('name');
        }

        // Update displayed price when checkbox is toggled (+$12 when checked)
        const currentVariant = variantData.find((v) => String(v.id) === String(idControl?.value));
        if (currentVariant) updatePriceWithEmbroidery(currentVariant, isChecked);
      });
    }

    // Thread color
    document.addEventListener('change', function (event) {
      if (event.target.matches('[name="properties[Embroidery color]"]')) {
        const preview = document.getElementById('embroidery-text-preview');
        preview.classList.remove(...EMBROIDERY_PREVIEW_COLOR_CLASSES);
        preview.classList.add(embroideryColorToPreviewClass(event.target.value));
      }
    });

    // Font
    document.addEventListener('change', function (event) {
      if (event.target.matches('[name="properties[Embroidery font]"]')) {
        const font = event.target.value.toLowerCase().replace(' ', '-');

        const preview = document.getElementById('embroidery-text-preview');
        preview.classList.remove('font-helvetica', 'font-athletic-flair', 'font-flair');
        preview.classList.add(`font-${font}`);
      }
    });

    function getEmbroideryCharacterUnits(text) {
      return Array.from(text || '').reduce((total, char) => {
        return total + (/[A-Z]/.test(char) ? 2 : 1);
      }, 0);
    }

    function truncateEmbroideryTextByUnits(text, maxUnits) {
      let units = 0;
      let result = '';

      for (const char of Array.from(text || '')) {
        const charUnits = /[A-Z]/.test(char) ? 2 : 1;
        if (units + charUnits > maxUnits) break;
        result += char;
        units += charUnits;
      }

      return result;
    }

    // Live text
    const embroideryTextInput = document.getElementById('embroidery-text');
    if (embroideryTextInput) {
      embroideryTextInput.addEventListener('input', function (event) {
        const limitedValue = truncateEmbroideryTextByUnits(event.target.value, 10);
        if (event.target.value !== limitedValue) {
          event.target.value = limitedValue;
        }

        const preview = document.getElementById('embroidery-text-preview');
        if (preview) preview.textContent = limitedValue;
        const charCount = getEmbroideryCharacterUnits(limitedValue);
        let fontSize = 70;
        if (charCount > 4) fontSize -= charCount * 2;
        if (preview) preview.style.fontSize = fontSize + 'px';
      });
    }
  }

  // Init on first load
  if (idControl) {
    initEmblaForVariant(idControl.value);
    updateEmbroideryColorOptions(idControl.value);

    const initialVariant = allVariantData.find((variant) => String(variant.id) === String(idControl.value));
    if (initialVariant) {
      syncHoodOptionFromVariant(initialVariant);
    } else if (ginghamHoodConfig) {
      const colorField = rootEl.querySelector('.main-product-new-content__option[data-option-index="0"]');
      const checkedColor = colorField?.querySelector('input:checked');
      if (checkedColor) updateHoodOptionVisibility(checkedColor.value);
    }
  }

  // Wunderkind initial item views
  try {
    wunderkindSDK('item', {
      id: `${productData.id}`,
      copy: productData?.title,
      category: 'Global',
      url: window.location.origin + window.location.pathname,
      imageurl: 'https:' + productData?.featured_image,
      instock: productData?.available ? 'true' : 'false',
    });

    const variant = findMatchingVariant();

    wunderkindSDK('viewItem', {
      'item:id': `${productData.id}`,
      'item:itemgroupid': `${productData.id}`,
    });
  } catch (err) {
    console.log('Failed to send wunderkind:', err);
  }

  // Sticky bar
  if (stickyBar) {
    window.addEventListener('scroll', function () {
      if (window.scrollY >= stickyBarTriggerPoint) {
        stickyBar.classList.add('sticky-add-to-cart--active');
      } else {
        stickyBar.classList.remove('sticky-add-to-cart--active');
      }
    });
  }

  if (stickyBarSelect) {
    stickyBarSelect.addEventListener('change', (e) => {
      const variantId = Number(e.target.value);
      const variant = allVariantData.find((v) => v.id === variantId);
      if (variant) handleVariantChange(variant);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-new"] && !Shopify.designMode) return;
  try {
    
  // State
  let emblaInstance = null;

  // Elements
  const rootEl = document.querySelector('.main-product-new');
  const idControl = rootEl.querySelector('[name="id"]');

  const allEmblaWrappers = rootEl.querySelectorAll('.embla-wrapper');
  const swatchInputs = rootEl.querySelectorAll('.swatch__input');
  const price = rootEl.querySelector('.main-product-new-content__price');
  const compare = rootEl.querySelector('.main-product-new-content__compare');
  const selectedOptionLabels = rootEl.querySelectorAll('.main-product-new-content__option-label-selection');
  const add = rootEl.querySelector('.main-product-new-content__add');
  const pairingBlocks = document.querySelectorAll('.main-product-new-content__pairing');
  const accordions = document.querySelectorAll('.main-product-new-content__accordion');
  const allPrevBtns = document.querySelectorAll('.embla__button--prev');
  const allNextBtns = document.querySelectorAll('.embla__button--next');
  const tushbabyTooltip = rootEl.querySelector('.tushbaby-lite-tooltip');

  // Data
  const productJsonString = document.querySelector('#product-json').textContent;
  const productData = JSON.parse(productJsonString);
  const productInventoryJsonString = document.querySelector('#product-inventory').textContent;
  const productInventoryJson = JSON.parse(productInventoryJsonString);
  const variantPreorderMapString = document.querySelector('#variant-preorder-map').textContent;
  const variantPreorderMap = JSON.parse(variantPreorderMapString);
  const variantData = productData.variants;
  const moneyFormat = rootEl.getAttribute('data-money-format');
  const moneyFormatExample = rootEl.getAttribute('data-money-format-example');
  const lowInventoryThresholdString = rootEl.getAttribute('data-low-inventory-threshold');
  const lowInventoryThreshold = lowInventoryThresholdString ? Number(lowInventoryThresholdString) : 150;
  const stickyBar = document.querySelector('.sticky-add-to-cart');
  const stickyBarTriggerPoint = 1300;
  const stickyBarSelect = document.querySelector('.sticky-add-to-cart__select');
  const stickySelect = document.querySelector('.sticky-add-to-cart__select');
  const stickyImg = document.querySelector('.sticky-add-to-cart__image img');
  const embroideryColorOptions = rootEl.querySelectorAll('.main-product-new-embroidery__color');
  const embroideryColorMapEl = document.querySelector('#embroidery-thread-colors-by-variant');
  const embroideryColorAvailabilityByVariantId = JSON.parse(embroideryColorMapEl?.textContent || '{}');

  const variantCustomFirstImages = JSON.parse(document.querySelector('#variant-custom-first-images').textContent);
  const variantUvPrintedMap = JSON.parse(document.querySelector('#variant-uv-printed-map')?.textContent || '{}');
  const embroideryToggleLabel = rootEl.querySelector('.main-product-new-embroidery-toggle__checkbox-label');
  const EMBROIDERY_TOGGLE_LABEL_DEFAULT = 'Add a name or monogram (+$12)';
  const EMBROIDERY_TOGGLE_LABEL_UV_PRINTED = 'Personalize with Premium UV Printing';

  function updateEmbroideryToggleLabel(variantId) {
    if (!embroideryToggleLabel) return;
    const isUvPrinted = Boolean(variantUvPrintedMap[String(variantId)]);
    embroideryToggleLabel.textContent = isUvPrinted
      ? EMBROIDERY_TOGGLE_LABEL_UV_PRINTED
      : EMBROIDERY_TOGGLE_LABEL_DEFAULT;
  }

  const DEFAULT_EMBROIDERY_COLORS = new Set(['black', 'silver', 'gold']);
  const EMBROIDERY_PREVIEW_COLOR_CLASSES = [
    'black',
    'silver',
    'gold',
    'pink',
    'blue',
    'black-solid',
    'silver-solid',
    'gold-solid',
    'pink-solid',
    'blue-solid',
  ];

  function embroideryColorToPreviewClass(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\s+/g, '-');
  }

  function parseEmbroideryThreadColorList(rawValue) {
    if (rawValue == null || rawValue === '') return null;

    let list = rawValue;
    if (!Array.isArray(list) && typeof list === 'object' && Array.isArray(list.value)) {
      list = list.value;
    }

    const values = Array.isArray(list)
      ? list
      : String(list)
          .split(/[,•|]/)
          .map((value) => value.trim())
          .filter(Boolean);

    return values.length ? values : null;
  }

  function getAllowedEmbroideryColorsForVariant(variantId) {
    const rawValue = embroideryColorAvailabilityByVariantId[String(variantId)];
    const values = parseEmbroideryThreadColorList(rawValue);

    if (!values) return DEFAULT_EMBROIDERY_COLORS;

    return new Set(values.map((value) => String(value).toLowerCase()));
  }

  function updateEmbroideryColorOptions(variantId) {
    if (!embroideryColorOptions.length) return;

    const allowedColors = getAllowedEmbroideryColorsForVariant(variantId);
    let firstVisibleInput = null;
    let hasCheckedVisible = false;

    embroideryColorOptions.forEach((colorOption) => {
      const input = colorOption.querySelector('input');
      if (!input) return;

      const colorName = String(input.value || '').toLowerCase();
      const isVisible = allowedColors.has(colorName);

      colorOption.style.display = isVisible ? '' : 'none';
      input.disabled = !isVisible;

      if (isVisible) {
        if (!firstVisibleInput) firstVisibleInput = input;
        if (input.checked) hasCheckedVisible = true;
      } else if (input.checked) {
        input.checked = false;
      }
    });

    if (!hasCheckedVisible && firstVisibleInput) {
      firstVisibleInput.checked = true;
      firstVisibleInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // Events
  swatchInputs.forEach((input) => {
    input.addEventListener('change', () => {
      const matchedVariant = findMatchingVariant();
      console.log('variant changed', matchedVariant);
      if (!matchedVariant) return;

      const swatches = input.closest('.main-product-new-content__option-swatches');
      const fieldset = swatches.parentElement;
      const legend = swatches.previousElementSibling;
      const label = legend.querySelector('.main-product-new-content__option-label-selection');
      const optionIndex = swatches.getAttribute('data-option-index');

      label.textContent = matchedVariant[`option${Number(optionIndex) + 1}`];
      
      if (idControl && idControl.value !== matchedVariant.id.toString()) {
        handleVariantChange(matchedVariant);
      }
    });
  });

  // Thumbnail click → scroll Embla and update active state
  document.querySelectorAll('.main-product-new-image-thumbnail').forEach((thumb) => {
    const thumbImage = thumb.querySelector('img');
    const thumbLabel = thumbImage?.getAttribute('alt') || 'View product image';

    if (!thumb.hasAttribute('role')) {
      thumb.setAttribute('role', 'button');
      thumb.setAttribute('tabindex', '0');
      thumb.setAttribute('aria-label', thumbLabel);
    }

    const activateThumbnail = () => {
      const index = parseInt(thumb.getAttribute('data-embla-index'));
      if (emblaInstance && !isNaN(index)) {
        emblaInstance.scrollTo(index);
      }

      const thumbnailGroup = thumb.closest('.main-product-new-image-thumbnails');
      thumbnailGroup.querySelectorAll('.main-product-new-image-thumbnail').forEach((el) => {
        el.classList.remove('main-product-new-image-thumbnail--active');
      });

      thumb.classList.add('main-product-new-image-thumbnail--active');
    };

    thumb.addEventListener('click', activateThumbnail);
    thumb.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        activateThumbnail();
      }
    });
  });

  // Attach arrow event listeners once on page load
  allPrevBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      if (emblaInstance) emblaInstance.scrollPrev();
    });
  });

  allNextBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      if (emblaInstance) emblaInstance.scrollNext();
    });
  });

  // Embroidery add-on price (cents) — update here if the embroidery product price changes
  const EMBROIDERY_PRICE_CENTS = 1200;

  function updatePriceWithEmbroidery(variant, isEmbroideryChecked) {
    if (!price || !variant) return;
    const addOn = isEmbroideryChecked ? EMBROIDERY_PRICE_CENTS : 0;
    const displayPrice = variant.price + addOn;
    const displayCompare = (variant.compare_at_price || 0) + addOn;

    price.textContent = formatMoney(moneyFormat, moneyFormatExample, displayPrice);
    compare.textContent = displayCompare > 0 ? formatMoney(moneyFormat, moneyFormatExample, displayCompare) : '';

    if (variant.compare_at_price > variant.price) {
      price.classList.add('main-product-new-content__price--active');
      compare.classList.add('main-product-new-content__compare--active');
    } else {
      price.classList.remove('main-product-new-content__price--active');
      compare.classList.remove('main-product-new-content__compare--active');
    }

  }

  // Helpers
  function updateActiveThumbnail(variantId) {
    const selectedIndex = emblaInstance.selectedScrollSnap();

    const activeThumbBlock = rootEl.querySelector(`.main-product-new-image-thumbnails--${variantId}`);
    if (!activeThumbBlock) return;

    const allThumbs = activeThumbBlock.querySelectorAll('.main-product-new-image-thumbnail');
    allThumbs.forEach((thumb, i) => {
      if (i === selectedIndex) {
        thumb.classList.add('main-product-new-image-thumbnail--active');
      } else {
        thumb.classList.remove('main-product-new-image-thumbnail--active');
      }
    });
  }

  function updateStickyCTA(newVariant) {
    const stickyBtn = document.querySelector('.sticky-add-to-cart button[type="submit"]');
    const label = stickyBtn?.querySelector('.sticky-add-to-cart__label');
    if (!stickyBtn || !label) return;

    const isPreorder = isVariantPreorder(newVariant);

    if (!newVariant.available && !isPreorder) {
      stickyBtn.disabled = true;
      label.textContent = 'Out of Stock';
      return;
    }

    stickyBtn.disabled = false;

    if (isPreorder) {
      label.textContent = 'Pre-Order Now';
    } else {
      label.textContent = 'Add to Cart';
    }
  }

  function isVariantPreorder(variantOrId) {
    const variantId = typeof variantOrId === 'object' ? variantOrId?.id : variantOrId;
    if (!variantId) return false;
    return Boolean(variantPreorderMap[String(variantId)]);
  }

  function handleVariantChange(newVariant) {
    if (!idControl) return;

    // 🔁 Sync swatch radios to the new variant
    const optionFields = rootEl.querySelectorAll('.main-product-new-content__option');

    optionFields.forEach((field, index) => {
      const value = newVariant[`option${index + 1}`];
      if (!value) return;

      const radio = field.querySelector(`input[value="${CSS.escape(value)}"]`);
      if (radio && !radio.checked) {
        radio.checked = true;
      }

      // Update label text
      const label = field.querySelector('.main-product-new-content__option-label-selection');
      if (label) label.textContent = value;
    });

    // Change input value
    idControl.value = newVariant.id;
    updateEmbroideryColorOptions(newVariant.id);

    // Change the url
    setUrlParam('variant', newVariant.id);

    // Update the carousel
    initEmblaForVariant(newVariant.id.toString());

    // Update thumbnails
    rootEl.querySelectorAll('.main-product-new-image-thumbnails').forEach((thumbBlock) => {
      thumbBlock.classList.remove('main-product-new-image-thumbnails--active');
    });
    const activeThumbBlock = rootEl.querySelector(`.main-product-new-image-thumbnails--${newVariant.id}`);
    if (activeThumbBlock) {
      activeThumbBlock.classList.add('main-product-new-image-thumbnails--active');

      // Set the active slide
      activeThumbBlock.querySelectorAll(`.main-product-new-image-thumbnail`).forEach((el, i) => {
        if (i == 0) {
          el.classList.add('main-product-new-image-thumbnail--active');
        } else {
          el.classList.remove('main-product-new-image-thumbnail--active');
        }
      });
    }

    // Update the price
    price.textContent = formatMoney(moneyFormat, moneyFormatExample, newVariant.price);
    compare.textContent = formatMoney(moneyFormat, moneyFormatExample, newVariant.compare_at_price);

    if (newVariant.compare_at_price > newVariant.price) {
      price.classList.add('main-product-new-content__price--active');
      compare.classList.add('main-product-new-content__compare--active');
    } else {
      price.classList.remove('main-product-new-content__price--active');
      compare.classList.remove('main-product-new-content__compare--active');
    }

    // Update preorder
    const preorderActiveClass = 'main-product-new-content__preorder-notice--active';

    rootEl.querySelectorAll('.main-product-new-content__preorder-notice').forEach((el) => {
      el.classList.remove(preorderActiveClass);
    });

    const preorder = rootEl.querySelector(`.main-product-new-content__preorder-notice--${newVariant.id}`);
    const isPreorder = isVariantPreorder(newVariant);

    if (isPreorder && preorder) {
      preorder.classList.add(preorderActiveClass);
    }

    // Update low inventory
    const lowInventoryEls = rootEl.querySelectorAll('.main-product-new__low-inventory');

    if (lowInventoryEls.length) {
      const manualPreorderAttr = add?.getAttribute('data-manual-preorder') || '';
      const manualPreorderVariantIds = manualPreorderAttr
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean);

      const lowInventoryActiveClass = 'main-product-new__low-inventory--active';
      const variantInventory = productInventoryJson[newVariant.id];
      const isForcePreorder = manualPreorderVariantIds.includes(newVariant.id.toString()) || isPreorder;

      lowInventoryEls.forEach((lowInventoryEl) => {
        if (!isForcePreorder && variantInventory < lowInventoryThreshold && variantInventory > 0) {
          lowInventoryEl.textContent = 'ONLY A FEW LEFT';
          lowInventoryEl.classList.add(lowInventoryActiveClass);
        } else {
          lowInventoryEl.textContent = '';
          lowInventoryEl.classList.remove(lowInventoryActiveClass);
        }
      });
    }

    function updateAccordionContent(type, variantId, defaultClass, accordionSelector) {
      // Remove all active states
      rootEl.querySelectorAll(`.main-product-new-content__${type}`).forEach((el) => {
        el.classList.remove(`main-product-new-content__${type}--active`);
      });

      // Activate variant-specific or fallback
      const variantBlock = document.querySelector(`.main-product-new-content__${type}--${variantId}`);
      if (variantBlock) {
        variantBlock.classList.add(`main-product-new-content__${type}--active`);
      } else {
        const defaultBlock = document.querySelector(`.main-product-new-content__${defaultClass}`);
        if (defaultBlock) defaultBlock.classList.add(`main-product-new-content__${type}--active`);
      }

      // Recalculate accordion height only if open
      const accordion = document.querySelector(accordionSelector);
      if (accordion && accordion.classList.contains('main-product-new-content__accordion--active')) {
        const body = accordion.querySelector('.main-product-new-content__accordion-body');
        if (body) body.style.maxHeight = body.scrollHeight + 'px';
      }
    }

    updateAccordionContent(
      'details',
      newVariant.id,
      'details--default',
      '.main-product-new-content__accordion--details'
    );
    updateAccordionContent(
      'materials',
      newVariant.id,
      'materials--default',
      '.main-product-new-content__accordion--materials'
    );
    updateAccordionContent('safety', newVariant.id, 'safety--default', '.main-product-new-content__accordion--safety');

    updateAccordionContent(
      'description',
      newVariant.id,
      'description--default',
      '.main-product-new-content__accordion--description'
    );

    // Update the add button
    if (isPreorder) {
      add.textContent = 'Pre-Order Now';
      add.disabled = false;
    } else if (newVariant.available) {
      add.textContent = 'Add to Cart';
      add.disabled = false;
    } else {
      add.textContent = 'Out of Stock';
      add.disabled = true;
    }

    // Update variant notes
    const noteCls = 'main-product-new-content__variant-note';
    const noteActiveCls = noteCls + '--active';
    const newNote = document.querySelector(`.${noteCls}--${newVariant.id}`);
    const oldNote = document.querySelector(`.${noteActiveCls}`);

    if (oldNote) oldNote.classList.remove(noteActiveCls);
    if (newNote) newNote.classList.add(noteActiveCls);

    // Update the embroidery image
    const embroideryWrapCls = 'main-product-new-embroidery-wrap';
    const embroideryWrap = document.querySelector(`.${embroideryWrapCls}`);

    if (embroideryWrap) {
      const embroideryWrapActiveCls = 'main-product-new-embroidery-wrap--active';
      const baseFabricCls = 'main-product-new-embroidery__fabric';
      const embroideryFabric = rootEl.querySelector(`.${baseFabricCls}--${newVariant.id}`);

      if (embroideryFabric) {
        updateEmbroideryToggleLabel(newVariant.id);

        // Display section
        document.querySelector(`.${embroideryWrapCls}`).classList.add(embroideryWrapActiveCls);

        // Display correct fabric image
        rootEl.querySelectorAll(`.${baseFabricCls}--active`).forEach((el) => {
          el.classList.remove(`${baseFabricCls}--active`);
        });
        embroideryFabric.classList.add(`${baseFabricCls}--active`);
      } else {
        // Hide section
        document.querySelector(`.${embroideryWrapCls}`).classList.remove(embroideryWrapActiveCls);
        document.querySelector('.main-product-new-embroidery').classList.remove('main-product-new-embroidery--active');

        // Hide embroidery-specific thumbnails
        document.querySelectorAll('[data-embroidery-thumb]').forEach((el) => {
          el.style.display = 'none';
        });

        // Untick toggle
        document.querySelector(`.main-product-new-embroidery-toggle__checkbox`).checked = false;

        document.querySelectorAll('.main-product-new-embroidery__font input').forEach((input) => {
          input.removeAttribute('name');
        });

        document.querySelectorAll('.main-product-new-embroidery__color input').forEach((input) => {
          input.removeAttribute('name');
        });

        document.getElementById('embroidery-text').removeAttribute('name');
      }
    }

    // Update tooltip
    if (tushbabyTooltip) {
      if (newVariant.id === 40092713287746) {
        tushbabyTooltip.classList.add('tushbaby-lite-tooltip--active');
      } else {
        tushbabyTooltip.classList.remove('tushbaby-lite-tooltip--active');
      }
    }

    // Send variant wunderkind event
    try {
      const variant = findMatchingVariant();

      // wunderkindSDK('viewItem', {
      //   'item:id': `item-${productData.id}`,
      //   'item:itemgroupid': `group-item-${productData.id}`,
      // })

      wunderkindSDK('selectItem', {
        'item:id': `${productData.id}`,
        'item:itemgroupid': `${productData.id}`,
        'item:feedid': `${variant.id}`,
      });
    } catch (err) {
      console.log('Failed to send wunderkind:', err);
    }

    // Sticky bar stuff
    try {
      if (stickySelect && stickySelect.value !== newVariant.id.toString()) {
        stickySelect.value = newVariant.id;
      }

      if (stickyImg) {
        let imgSrc = null;

        // 1) Variant featured image (Shopify JSON usually gives { src })
        if (newVariant.featured_image?.src) {
          imgSrc = newVariant.featured_image.src + '&width=300';
        } else if (typeof newVariant.featured_image === 'string') {
          imgSrc = newVariant.featured_image + '&width=300';
        }

        // 2) Fallback: first custom metafield image for that variant (from our JSON map)
        if (!imgSrc) {
          const custom = variantCustomFirstImages?.[newVariant.id];
          if (custom) imgSrc = custom; // already has width=300
        }

        // 3) Fallback: product featured image
        if (!imgSrc && productData.featured_image) {
          imgSrc = 'https:' + productData.featured_image + '&width=300';
        }

        if (imgSrc) {
          stickyImg.src = imgSrc;
          stickyImg.alt = newVariant.title || productData.title;
        }
      }

      updateStickyCTA(newVariant);
    } catch (err) {}
  }

  function initEmblaForVariant(variantId) {
    // Hide all Embla wrappers
    allEmblaWrappers.forEach((wrapper) => {
      wrapper.style.display = wrapper.dataset.variantId === variantId ? 'block' : 'none';
    });

    // Destroy previous instance
    if (emblaInstance) emblaInstance.destroy();

    // Find the correct viewport
    const targetWrapper = document.querySelector(`.embla-wrapper[data-variant-id="${variantId}"]`);
    const viewport = targetWrapper.querySelector('.embla__viewport');

    if (viewport) {
      requestAnimationFrame(() => {
        emblaInstance = EmblaCarousel(viewport, { loop: false }, [EmblaCarouselFade()]);

        // Setup dots
        const dotsContainer = targetWrapper.querySelector('.embla__dots');
        const slideCount = emblaInstance.slideNodes().length;
        dotsContainer.innerHTML = ''; // Clear previous dots

        for (let i = 0; i < slideCount; i++) {
          const dot = document.createElement('button');
          dot.classList.add('embla__dot');
          dot.type = 'button';
          dot.addEventListener('click', () => emblaInstance.scrollTo(i));
          dotsContainer.appendChild(dot);
        }

        function updateUI() {
          const selectedIndex = emblaInstance.selectedScrollSnap();

          // Update thumbnails
          const activeThumbBlock = rootEl.querySelector(`.main-product-new-image-thumbnails--${variantId}`);
          if (activeThumbBlock) {
            const allThumbs = activeThumbBlock.querySelectorAll('.main-product-new-image-thumbnail');
            allThumbs.forEach((thumb, i) => {
              thumb.classList.toggle('main-product-new-image-thumbnail--active', i === selectedIndex);
            });
          }

          // Update dots
          const allDots = dotsContainer.querySelectorAll('.embla__dot');
          allDots.forEach((dot, i) => {
            dot.classList.toggle('is-selected', i === selectedIndex);
          });

          // 🎥 Autoplay video in active slide
          const allSlides = emblaInstance.slideNodes();
          allSlides.forEach((slide, i) => {
            const video = slide.querySelector('video');
            if (video) {
              if (i === selectedIndex) {
                video.muted = true; // required for autoplay in most browsers
                video.loop = true;
                video.play().catch(() => {}); // prevent errors if not allowed
              } else {
                video.pause();
                video.currentTime = 0; // reset if you want it to start fresh
              }
            }
          });
        }

        emblaInstance.on('select', updateUI);
        updateUI();
      });
    }
  }

  function findMatchingVariant() {
    const optionFields = document.querySelectorAll('.main-product-new-content__option');
    const selectedValues = [];

    optionFields.forEach((field, i) => {
      const checked = field.querySelector('input:checked');
      if (checked) selectedValues[i] = checked.value;
    });

    return variantData.find((variant) => {
      return selectedValues.every((val, i) => variant[`option${i + 1}`] === val);
    });
  }

  // Pairings
  pairingBlocks.forEach((pairingBlock) => {
    // Parse pairing product JSON
    const productData = JSON.parse(pairingBlock.dataset.json);

    const selectEl = pairingBlock.querySelector('select[name="id"]');
    const priceEl = pairingBlock.querySelector('.main-product-new-content__pairing-main-top p');
    const imageEl = pairingBlock.querySelector('.main-product-new-content__pairing-image img');
    const addButton = pairingBlock.querySelector('button[type="submit"]');

    const updatePairingUI = (variantId) => {
      const variant = productData.variants.find((v) => v.id == Number(variantId));
      if (!variant) return;

      // Update price
      priceEl.textContent = formatMoney(moneyFormat, moneyFormatExample, variant.price).replace('.00', '');

      if (variant.featured_image) {
        imageEl.src = variant.featured_image.src + '&width=130';
        imageEl.alt = variant.featured_image.alt || productData.title;
      } else if (productData.featured_image) {
        imageEl.src = productData.featured_image.src + '&width=130';
        imageEl.alt = productData.featured_image.alt || productData.title;
      }

      // Update add button (disabled if out of stock)
      if (variant.available) {
        addButton.disabled = false;
        addButton.textContent = 'Add';
      } else {
        addButton.disabled = true;
        addButton.textContent = 'Sold Out';
      }
    };

    // On select change
    selectEl.addEventListener('change', (e) => {
      updatePairingUI(e.target.value);
    });
  });

  // Accordions
  accordions.forEach((accordion, accordionIndex) => {
    const header = accordion.querySelector('.main-product-new-content__accordion-header');
    const body = accordion.querySelector('.main-product-new-content__accordion-body');
    const heading = header?.querySelector('h3');
    const bodyId = `product-accordion-body-${accordionIndex}`;

    if (!header || !body) return;

    body.id = bodyId;
    header.setAttribute('role', 'button');
    header.setAttribute('tabindex', '0');
    header.setAttribute('aria-expanded', accordion.classList.contains('main-product-new-content__accordion--active') ? 'true' : 'false');
    header.setAttribute('aria-controls', bodyId);
    if (heading) header.setAttribute('aria-label', heading.textContent.trim());

    const toggleAccordion = () => {
      const isActive = accordion.classList.contains('main-product-new-content__accordion--active');

      if (isActive) {
        accordion.classList.remove('main-product-new-content__accordion--active');
        body.style.maxHeight = '0';
        header.setAttribute('aria-expanded', 'false');
      } else {
        accordion.classList.add('main-product-new-content__accordion--active');
        body.style.maxHeight = body.scrollHeight + 'px';
        header.setAttribute('aria-expanded', 'true');
      }
    };

    header.addEventListener('click', toggleAccordion);
    header.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggleAccordion();
      }
    });
  });

  // Embroidery
  const embroidery = document.querySelector('.main-product-new-embroidery');

  if (embroidery && idControl) {
    const embroideryActiveCls = 'main-product-new-embroidery--active';
    const embroideryToggle = document.querySelector('#embroidery__checkbox');

    if (embroideryToggle) {
      embroideryToggle.addEventListener('change', (e) => {
        const isChecked = e.target.checked;
        if (isChecked) {
          embroidery.classList.add(embroideryActiveCls);

          document.querySelectorAll('[data-embroidery-thumb]').forEach((el) => {
            el.style.display = 'block';
          });

          document.querySelectorAll('.main-product-new-embroidery__font input').forEach((input) => {
            input.setAttribute('name', 'properties[Embroidery font]');
          });

          document.querySelectorAll('.main-product-new-embroidery__color input').forEach((input) => {
            input.setAttribute('name', 'properties[Embroidery color]');
          });

          document.getElementById('embroidery-text').setAttribute('name', 'properties[Embroidery text]');
        } else {
          embroidery.classList.remove(embroideryActiveCls);

          document.querySelectorAll('[data-embroidery-thumb]').forEach((el) => {
            el.style.display = 'none';
          });

          document.querySelectorAll('.main-product-new-embroidery__font input').forEach((input) => {
            input.removeAttribute('name');
          });

          document.querySelectorAll('.main-product-new-embroidery__color input').forEach((input) => {
            input.removeAttribute('name');
          });

          document.getElementById('embroidery-text').removeAttribute('name');
        }

        // Update displayed price when checkbox is toggled (+$12 when checked)
        const currentVariant = variantData.find((v) => String(v.id) === String(idControl?.value));
        if (currentVariant) updatePriceWithEmbroidery(currentVariant, isChecked);
      });
    }

    // Thread color
    document.addEventListener('change', function (event) {
      if (event.target.matches('[name="properties[Embroidery color]"]')) {
        const preview = document.getElementById('embroidery-text-preview');
        preview.classList.remove(...EMBROIDERY_PREVIEW_COLOR_CLASSES);
        preview.classList.add(embroideryColorToPreviewClass(event.target.value));
      }
    });

    // Font
    document.addEventListener('change', function (event) {
      if (event.target.matches('[name="properties[Embroidery font]"]')) {
        const font = event.target.value.toLowerCase().replace(' ', '-');

        const preview = document.getElementById('embroidery-text-preview');
        preview.classList.remove('font-helvetica', 'font-athletic-flair', 'font-flair');
        preview.classList.add(`font-${font}`);
      }
    });

    function getEmbroideryCharacterUnits(text) {
      return Array.from(text || '').reduce((total, char) => {
        return total + (/[A-Z]/.test(char) ? 2 : 1);
      }, 0);
    }

    function truncateEmbroideryTextByUnits(text, maxUnits) {
      let units = 0;
      let result = '';

      for (const char of Array.from(text || '')) {
        const charUnits = /[A-Z]/.test(char) ? 2 : 1;
        if (units + charUnits > maxUnits) break;
        result += char;
        units += charUnits;
      }

      return result;
    }

    // Live text
    const embroideryTextInput = document.getElementById('embroidery-text');
    if (embroideryTextInput) {
      embroideryTextInput.addEventListener('input', function (event) {
        const limitedValue = truncateEmbroideryTextByUnits(event.target.value, 10);
        if (event.target.value !== limitedValue) {
          event.target.value = limitedValue;
        }

        const preview = document.getElementById('embroidery-text-preview');
        if (preview) preview.textContent = limitedValue;
        const charCount = getEmbroideryCharacterUnits(limitedValue);
        let fontSize = 70;
        if (charCount > 4) fontSize -= charCount * 2;
        if (preview) preview.style.fontSize = fontSize + 'px';
      });
    }
  }

  // Init on first load
  if (idControl) {
    initEmblaForVariant(idControl.value);
    updateEmbroideryColorOptions(idControl.value);
  }

  // Wunderkind initial item views
  try {
    wunderkindSDK('item', {
      id: `${productData.id}`,
      copy: productData?.title,
      category: 'Global',
      url: window.location.origin + window.location.pathname,
      imageurl: 'https:' + productData?.featured_image,
      instock: productData?.available ? 'true' : 'false',
    });

    const variant = findMatchingVariant();

    wunderkindSDK('viewItem', {
      'item:id': `${productData.id}`,
      'item:itemgroupid': `${productData.id}`,
    });
  } catch (err) {
    console.log('Failed to send wunderkind:', err);
  }

  // Sticky bar
  if (stickyBar) {
    window.addEventListener('scroll', function () {
      if (window.scrollY >= stickyBarTriggerPoint) {
        stickyBar.classList.add('sticky-add-to-cart--active');
      } else {
        stickyBar.classList.remove('sticky-add-to-cart--active');
      }
    });
  }

  if (stickyBarSelect) {
    stickyBarSelect.addEventListener('change', (e) => {
      const variantId = Number(e.target.value);
      const variant = variantData.find((v) => v.id === variantId);
      if (variant) handleVariantChange(variant);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"] && !Shopify.designMode) return;
  try {
    
  ;(function () {
    // SORT BY SELECT
    const sortBy = document.getElementById('sort-by')

    if (sortBy) {
      const qp = {}

      // Preserve existing query parameters
      if (location.search.length > 1) {
        const params = location.search.substring(1).split('&')

        params.forEach((param) => {
          const [key, value] = param.split('=')
          if (key) {
            qp[decodeURIComponent(key)] = decodeURIComponent(value || '')
          }
        })
      }

      // Update sort_by query parameter on change
      sortBy.addEventListener('change', function (e) {
        qp.sort_by = e.target.value
        location.search = new URLSearchParams(qp).toString()
      })
    }

    // GRID TYPE TOGGLE
    const gridTypeButtons = document.querySelectorAll('.main-collection-grid-type')
    const grid = document.querySelector('.main-collection-grid')

    gridTypeButtons.forEach((button) => {
      button.addEventListener('click', function () {
        // Remove active state from all buttons
        gridTypeButtons.forEach((btn) => btn.classList.remove('main-collection-grid-type--active'))

        // Activate clicked button
        this.classList.add('main-collection-grid-type--active')

        // Toggle grid layout
        if (this.classList.contains('main-collection-grid-type--threes')) {
          grid?.classList.add('main-collection-grid--3')
        } else {
          grid?.classList.remove('main-collection-grid--3')
        }
      })
    })

    const form = document.querySelector('#filters')
    if (!form) return

    const applyButton = document.querySelector('.main-collection-sidebar__footer-apply')
    const clearButton = document.querySelector('.main-collection-sidebar__footer-clear')
    const isMobile = () => window.innerWidth < 800

    const sliderEl = document.getElementById('price-slider')
    const hiddenMin = document.getElementById('price-min')
    const hiddenMax = document.getElementById('price-max')
    const displayMin = document.getElementById('range-display-min')
    const displayMax = document.getElementById('range-display-max')

    const defaultMin = 0
    const defaultMax = hiddenMax ? parseInt(hiddenMax.defaultValue || '100', 10) : 100

    /* ----------------------------
     FILTER COUNT
  ---------------------------- */
    function updateFilterCount() {
      const checkedCount = form.querySelectorAll('input[type="checkbox"]:checked').length

      const minVal = parseInt(hiddenMin?.value || '0', 10)
      const maxVal = parseInt(hiddenMax?.value || '0', 10)

      const priceSelected = minVal !== defaultMin || maxVal !== defaultMax

      const totalFilters = checkedCount + (priceSelected ? 1 : 0)

      if (applyButton) {
        applyButton.innerHTML = `Apply Filters (${totalFilters})`
      }
    }

    /* ----------------------------
     APPLY / BUILD URL
  ---------------------------- */
    function buildURLFromFilters() {
      const url = new URL(window.location.href)
      const params = new URLSearchParams(url.search)

      // Remove existing filter params
      Array.from(params.keys()).forEach((key) => {
        if (key.startsWith('filter.')) {
          params.delete(key)
        }
      })

      // Add checked checkboxes
      form.querySelectorAll('input[type="checkbox"]:checked').forEach((input) => {
        params.append(input.name, input.value)
      })

      // Price filters
      const priceMin = form.querySelector('input[name="filter.v.price.gte"]')
      const priceMax = form.querySelector('input[name="filter.v.price.lte"]')

      if (priceMin && priceMin.value !== '') {
        params.set('filter.v.price.gte', priceMin.value)
      }

      if (priceMax && priceMax.value !== '') {
        params.set('filter.v.price.lte', priceMax.value)
      }

      // Search query
      const searchInput = form.querySelector('input[name="q"]')
      if (searchInput && searchInput.value) {
        params.set('q', searchInput.value)
      }

      // Preserve Shopify prefix option
      const prefix = url.searchParams.get('options[prefix]')
      if (prefix) {
        params.set('options[prefix]', prefix)
      }

      return `${window.location.pathname}?${params.toString()}`
    }

    function applyFilters() {
      window.location.href = buildURLFromFilters()
    }

    /* ----------------------------
     CHECKBOX EVENTS
  ---------------------------- */
    form.querySelectorAll('input[type="checkbox"]').forEach((input) => {
      input.addEventListener('change', function () {
        updateFilterCount()
        if (!isMobile()) {
          applyFilters()
        }
      })
    })

    /* ----------------------------
     APPLY / CLEAR BUTTONS
  ---------------------------- */
    if (applyButton) {
      applyButton.addEventListener('click', function () {
        applyFilters()
      })
    }

    if (clearButton) {
      clearButton.addEventListener('click', function () {
        form.querySelectorAll('input[type="checkbox"]').forEach((input) => {
          input.checked = false
        })

        if (sliderEl && sliderEl.noUiSlider) {
          sliderEl.noUiSlider.set([defaultMin, defaultMax])
        }

        updateFilterCount()

        if (!isMobile()) {
          applyFilters()
        }
      })
    }

    /* ----------------------------
     PRICE SLIDER
  ---------------------------- */
    if (sliderEl && hiddenMin && hiddenMax && displayMin && displayMax && window.noUiSlider) {
      const max = parseInt(sliderEl.dataset.max || hiddenMax.defaultValue || '100', 10)

      const startMin = parseInt(hiddenMin.value || defaultMin, 10)
      const startMax = parseInt(hiddenMax.value || max, 10)

      noUiSlider.create(sliderEl, {
        start: [startMin, startMax],
        connect: true,
        range: {
          min: 0,
          max: 300,
        },
        step: 1,
      })

      sliderEl.noUiSlider.on('update', function (values) {
        const min = Math.round(values[0])
        const max = Math.round(values[1])

        displayMin.textContent = min
        displayMax.textContent = max
        hiddenMin.value = min
        hiddenMax.value = max

        updateFilterCount()
      })

      sliderEl.noUiSlider.on('change', function () {
        if (!isMobile()) {
          applyFilters()
        }
      })
    }

    updateFilterCount()

    /* ----------------------------
     SORT DROPDOWN
  ---------------------------- */
    const sortSelect = document.querySelector('#sort_by')
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        const url = new URL(window.location.href)
        const params = new URLSearchParams(url.search)

        params.set('sort_by', this.value)
        window.location.href = `${window.location.pathname}?${params.toString()}`
      })
    }

    /* ----------------------------
     FILTER SIDEBAR TOGGLE
  ---------------------------- */
    const filtersToggle = document.querySelector('.main-collection-info__filters')
    const filtersSidebar = document.querySelector('.main-collection-sidebar')
    const filtersClose = document.querySelector('.main-collection-sidebar__close')

    if (filtersToggle && filtersSidebar && filtersClose) {
      filtersToggle.addEventListener('click', function (e) {
        e.preventDefault()
        filtersSidebar.classList.toggle('main-collection-sidebar--active')
      })

      filtersClose.addEventListener('click', function (e) {
        e.preventDefault()
        filtersSidebar.classList.remove('main-collection-sidebar--active')
      })
    }

    /* ----------------------------
     DROPDOWNS
  ---------------------------- */
    document.querySelectorAll('.main-collection-dropdown').forEach((dropdown) => {
      const header = dropdown.querySelector('.main-collection-dropdown__header')
      const body = dropdown.querySelector('.main-collection-dropdown__body')
      if (!header || !body) return

      dropdown.classList.add('main-collection-dropdown--active')
      body.style.maxHeight = body.scrollHeight + 'px'

      header.addEventListener('click', function () {
        const isActive = dropdown.classList.toggle('main-collection-dropdown--active')

        body.style.maxHeight = isActive ? body.scrollHeight + 'px' : '0px'
      })
    })

    // Wunderkind
    try {
      const collection = document.querySelector('[data-collection-ids]')
      if (collection) {
        const ids = collection.getAttribute('data-collection-ids')
        window.wunderkindSDK('viewCategory', {
          'items:ids': ids.split(',').filter((item) => item !== ''),
          'page:url': window.location.href,
        })
      }
    } catch (err) {
      console.log('Failed to send wunderkind data', err)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mystery-faqs"] && !Shopify.designMode) return;
  try {
    
  const faqQuestions = document.querySelectorAll('.faq-new-question');

  faqQuestions.forEach((faq) => {
    const header = faq.querySelector('.faq-new-question__header');
    const body = faq.querySelector('.faq-new-question__body');
    const bodyInner = faq.querySelector('.faq-new-question__body-inner');

    header.addEventListener('click', function () {
      const isActive = faq.classList.contains('faq-new-question--active');

      // Close all FAQs first (if you want accordion behavior — remove this if you want multiple open)
      faqQuestions.forEach((f) => {
        f.classList.remove('faq-new-question--active');
        f.querySelector('.faq-new-question__body').style.maxHeight = '0';
      });

      if (!isActive) {
        faq.classList.add('faq-new-question--active');
        body.style.maxHeight = bodyInner.scrollHeight + 'px';
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-arrivals-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Wunderkind
    try {
      const collection = document.querySelector('[data-collection-ids]');
      if (collection) {
        const ids = collection.getAttribute('data-collection-ids');
        window.wunderkindSDK('viewCategory', {
          'items:ids': ids.split(',').filter((item) => item !== ''),
          'page:url': window.location.href,
        });
      }
    } catch (err) {
      console.log('Failed to send wunderkind data', err);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["on-sale-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Wunderkind
    try {
      const collection = document.querySelector('[data-collection-ids]');
      if (collection) {
        const ids = collection.getAttribute('data-collection-ids');
        window.wunderkindSDK('viewCategory', {
          'items:ids': ids.split(',').filter((item) => item !== ''),
          'page:url': window.location.href,
        });
      }
    } catch (err) {
      console.log('Failed to send wunderkind data', err);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-also"] && !Shopify.designMode) return;
  try {
    
  const rootEl = document.querySelector('.product-also')
  if (!rootEl) return

  const moneyFormat = rootEl.getAttribute('data-money-format')
  const moneyFormatExample = rootEl.getAttribute('data-money-format-example')

  // Product Also Blocks
  document.querySelectorAll('.product-also-product').forEach((productBlock) => {
    const productData = JSON.parse(productBlock.dataset.json)
    const selectEl = productBlock.querySelector('select[name="id"]')
    const priceEl = productBlock.querySelector('p')
    const imageEl = productBlock.querySelector('img')
    const addButton = productBlock.querySelector('button[type="submit"]')

    const updateProductAlsoUI = (variantId) => {
      const variant = productData.variants.find((v) => {
        return v.id === Number(variantId)
      })
      if (!variant) return

      // Update price
      priceEl.textContent = formatMoney(moneyFormat, moneyFormatExample, variant.price).replace('.00', '')

      // Update image
      if (variant.featured_image) {
        imageEl.src = variant.featured_image.src + '&width=750'
        imageEl.alt = variant.featured_image.alt || productData.title
      } else if (productData.featured_image) {
        imageEl.src = productData.featured_image.src + '&width=750'
        imageEl.alt = productData.featured_image.alt || productData.title
      }

      // Update add button
      if (variant.available) {
        addButton.disabled = false
        addButton.textContent = 'Add to Cart'
      } else {
        addButton.disabled = true
        addButton.textContent = 'Sold Out'
      }
    }

    // On select change
    selectEl.addEventListener('change', (e) => {
      updateProductAlsoUI(e.target.value)
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  const viewport = document.querySelector('.testimonials .embla__viewport')
  const dotsContainer = document.querySelector('.testimonials .embla__dots')

  if (!viewport || !dotsContainer) return

  let embla
  let dots = []

  const getSlidesToScroll = () => {
    const width = window.innerWidth
    if (width >= 1040) return 3
    if (width >= 600) return 2
    return 1
  }

  const setupEmbla = () => {
    if (embla) embla.destroy()

    embla = EmblaCarousel(viewport, {
      loop: false,
      align: 'start',
      containScroll: 'trimSnaps',
      slidesToScroll: getSlidesToScroll(),
    })

    generateDots()
    embla.on('select', updateDots)
    embla.on('reInit', () => {
      generateDots()
      updateDots()
    })
    updateDots()
  }

  /* ---------- CHANGED #1 ---------- */
  const generateDots = () => {
    dotsContainer.innerHTML = ''
    const pageCount = embla.scrollSnapList().length

    dots = Array.from({ length: pageCount }, (_, index) => {
      const dot = document.createElement('button')
      dot.classList.add('embla__dot')
      dot.type = 'button'
      dot.id = `testimonial-tab-${index}`
      dot.setAttribute('role', 'tab')
      dot.setAttribute('aria-controls', `testimonial-panel-${index}`)
      dot.setAttribute('aria-selected', index === 0 ? 'true' : 'false')
      dot.setAttribute('tabindex', index === 0 ? '0' : '-1')
      dot.setAttribute('aria-label', `Go to testimonial ${index + 1}`)
      dot.addEventListener('click', () => embla.scrollTo(index))
      dotsContainer.appendChild(dot)
      return dot
    })
  }

  /* ---------- CHANGED #3 ---------- */
  const updateDots = () => {
    const selectedIndex = embla.selectedScrollSnap()
    dots.forEach((dot, index) => {
      const isSelected = index === selectedIndex
      dot.classList.toggle('is-selected', isSelected)
      dot.setAttribute('aria-selected', isSelected ? 'true' : 'false')
      dot.setAttribute('tabindex', isSelected ? '0' : '-1')
    })
  }

  setupEmbla()
  window.addEventListener('resize', setupEmbla)

  } catch(e) { console.error(e); }
})();
})();
